<div class="p-blockui p-component-overlay" *ngIf="dialogBlock" style="z-index: 100;"></div>
<div class="operate-button">
    <p-speedDial [model]="operatePageButtons" direction="down-left" type="quarter-circle" showIcon="pi pi-folder"
        hideIcon="pi pi-folder-open"></p-speedDial>
</div>
<div class="layout-content" [ngStyle]="{'height': httpHelp.pageHeight}">
    <div class="search-panel" #driverSearchPanel>
        <form id="formGroup" [formGroup]="searchForm" (resized)="formResize($event)">
            <div class="form-item" name="startTime" *ngIf="searchFormName['startTime']['show']">
                <label for="startTime" class="p-mr-2 p-d-inline">注册时间</label>
                <p-calendar formControlName="startTime" id="startTime" class="p-inputtext-sm" dateFormat="yy-mm-dd"
                    dataType="string"></p-calendar>
            </div>
            <div class="form-item" name="endTime" *ngIf="searchFormName['endTime']['show']">
                <label for="endTime" class="p-mr-2 p-d-inline p-ml-2">至</label>
                <p-calendar formControlName="endTime" id="endTime" class="p-inputtext-sm" dateFormat="yy-mm-dd"
                    dataType="string"></p-calendar>
            </div>
            <div class="form-item" name="cusId" *ngIf="searchFormName['cusId']['show']">
                <label for="cusId" class="p-mr-2 p-d-inline">托运方</label>
                <p-dp-detail [options]="searchShipperList" formControlName="cusId" emptyMessage="未查询到数据"
                    emptyFilterMessage="未查询到数据" class="p-mr-2 p-d-inline p-inputtext-sm" id="cusId" appendTo="body"
                    filter="true" [style]="{'width':'165px'}">
                </p-dp-detail>
            </div>

            <div class="form-item" name="realname" *ngIf="searchFormName['realname']['show']">
                <label for="realname" class="p-mr-2 p-d-inline">司机姓名</label>
                <input type="text" id="realname" pInputText class="p-mr-2 p-d-inline" class="p-inputtext-sm"
                    formControlName="realname" />
            </div>

            <div class="form-item" name="saleUserName" *ngIf="searchFormName['saleUserName']['show']">
                <label for="saleUserName" class="p-mr-2 p-d-inline">业务员</label>
                <p-dp-detail [options]="saleUserNameList" formControlName="saleUserName" emptyMessage="未查询到数据"
                    emptyFilterMessage="未查询到数据" class="p-mr-2 p-d-inline p-inputtext-sm" id="saleUserName"
                    appendTo="body" filter="true" [style]="{'width':'165px'}">
                </p-dp-detail>
            </div>

            <div class="form-item" name="mobilePhone" *ngIf="searchFormName['mobilePhone']['show']">
                <label for="mobilePhone" class="p-mr-2 p-d-inline">手机号</label>
                <input type="text" id="mobilePhone" pInputText class="p-mr-2 p-d-inline" class="p-inputtext-sm"
                    formControlName="mobilePhone" />
            </div>

            <div class="form-item" name="idCardNo" *ngIf="searchFormName['idCardNo']['show']">
                <label for="idCardNo" class="p-mr-2 p-d-inline">身份证号</label>
                <input type="text" id="idCardNo" pInputText class="p-mr-2 p-d-inline" class="p-inputtext-sm"
                    formControlName="idCardNo" />
            </div>
            <div class="form-item" name="sex" *ngIf="searchFormName['sex']['show']">
                <label for="sex" class="p-mr-2 p-d-inline">性别</label>
                <p-dp-detail [options]="sexList" formControlName="sex" class="p-mr-2 p-d-inline p-inputtext-sm" id="sex"
                    appendTo="body" [style]="{'width':'165px'}">
                </p-dp-detail>
            </div>
            <div class="form-item" name="useStatus" *ngIf="searchFormName['useStatus']['show']">
                <label for="useStatus" class="p-mr-2 p-d-inline">工作状态</label>
                <p-dp-detail [options]="useStatusList" formControlName="useStatus"
                    class="p-mr-2 p-d-inline p-inputtext-sm" id="useStatus" appendTo="body" [style]="{'width':'165px'}">
                </p-dp-detail>
            </div>
            <div class="form-item" name="status" *ngIf="searchFormName['status']['show']">
                <label for="status" class="p-mr-2 p-d-inline">司机状态</label>
                <p-dp-detail [options]="statusList" formControlName="status" class="p-mr-2 p-d-inline p-inputtext-sm"
                    id="status" appendTo="body" [style]="{'width':'165px'}">
                </p-dp-detail>
            </div>
            <div class="form-item" name="signStatus" *ngIf="searchFormName['signStatus']['show']">
                <label for="signStatus" class="p-mr-2 p-d-inline">签署状态</label>
                <p-dp-detail [options]="signStatusList" formControlName="signStatus"
                    class="p-mr-2 p-d-inline p-inputtext-sm" id="signStatus" appendTo="body"
                    [style]="{'width':'165px'}">
                </p-dp-detail>
            </div>
            <div class="form-item" name="mobilePhone" *ngIf="searchFormName['mobilePhone']['show']">
                <label for="mobilePhones" class="p-mr-2 p-d-inline">批量司机</label>
                <input type="text" id="mobilePhones" pInputText class="p-mr-2 p-d-inline" class="p-inputtext-sm"
                    formControlName="mobilePhones" />
                <div style="margin-left: 5px;">
                    <i class="pi pi-plus-circle" style="font-size: 18px;cursor: pointer;color: rgb(139, 167, 151);"
                        (click)="batchMobilePhone()"></i>
                </div>
            </div>
            <div class="form-item" name="idCardNo" *ngIf="searchFormName['idCardNo']['show']">
                <label for="idCardNos" class="p-mr-2 p-d-inline">批量身份证号</label>
                <input type="text" id="idCardNos" pInputText class="p-mr-2 p-d-inline" class="p-inputtext-sm"
                    formControlName="idCardNos" />
                <div style="margin-left: 5px;">
                    <i class="pi pi-plus-circle" style="font-size: 18px;cursor: pointer;color: rgb(139, 167, 151);"
                        (click)="batchIdCardNo()"></i>
                </div>
            </div>
            <div class="form-item" name="blacklistStatus" *ngIf="searchFormName['blacklistStatus']['show']">
                <label for="blacklistStatus" class="p-mr-2 p-d-inline">是否黑名单</label>
                <p-dp-detail [options]="blacklistStatusList" formControlName="blacklistStatus"
                    class="p-mr-2 p-d-inline p-inputtext-sm" id="status" appendTo="body" [style]="{'width':'165px'}">
                </p-dp-detail>
            </div>
            <div class="form-item" name="agentId" *ngIf="searchFormName['agentId']['show']">
                <label for="agentId" class="p-mr-2 p-d-inline">区域合伙人</label>
                <p-dp-detail [options]="searchAgentList" formControlName="agentId" emptyMessage="未查询到数据"
                    emptyFilterMessage="未查询到数据" class="p-mr-2 p-d-inline p-inputtext-sm" id="agentId" appendTo="body"
                    filter="true" [style]="{'width':'165px'}">
                </p-dp-detail>
            </div>
        </form>
        <div
            style="width: 225px;color:var(--primary-color);font-size: small;cursor: pointer;display: flex;align-items: center;justify-content: flex-end;">
              <button pButton type="button" label="查询" icon="pi pi-search" class="p-button-sm" (click)="queryList()"></button>
               <button pButton type="button" label="重置" icon="pi pi-replay" class="p-button-sm p-ml-2 p-button-outlined" (click)="resetQuery()"></button>
            <!-- <auth-button buttonId="drivers_query" type="button" label="查询" icon="pi pi-search" buttonClass="p-button-sm"
                (onClick)="queryList()"></auth-button>
            <auth-button buttonId="drivers_query" type="button" label="重置" icon="pi pi-replay"
                buttonClass="p-button-sm p-ml-2 p-button-outlined" (onClick)="resetQuery()"></auth-button> -->
            <div class="p-ml-2" style="display: flex;align-items: center;">
                <i class="pi pi-angle-double-down" *ngIf="!showEsSearch" (click)="showEsQuery()"></i>
                <i class="pi pi-angle-double-up" *ngIf="showEsSearch" (click)="showEsQuery()"></i>
            </div>
        </div>
    </div>
    <div>
        <ng-container *ngFor="let item of hideSearchValue">
            <p-chip [label]="item['label'] + ':' + item['value']" [removable]="true" (onRemove)="deleteEsQuery(item)"
                class="p-ml-2" styleClass="custom-chip" icon="pi pi-search"></p-chip>
        </ng-container>
    </div>
    <div style="padding: 5px 0;">
        <div class="p-d-flex p-ai-center p-jc-between">
            <div class="p-d-flex search-panel-status">
                <ng-container *ngFor="let item of statusItems">
                    <div class="search-status" pRipple [ngClass]="{'search_status_active': item['checkFlag']}"
                        (click)="changeSearchStatus(item['value'])">
                        {{item['label']}} <p-badge size="smaller" [value]="item['value']"
                            [severity]="item['checkFlag'] ? 'danger': 'info'" styleClass="p-ml-1"></p-badge>
                    </div>
                </ng-container>
            </div>
            <div class="p-d-flex search-panel-status">
                <ng-container *ngFor="let item of certificateExpiredCountItems">
                    <div class="search-status" pRipple [ngClass]="{'search_status_active': item['checkFlag']}"
                        (click)="changeCertificateExpiredCountItems(item['value'])">
                        {{item['label']}} <p-badge size="smaller" [value]="item['value']"
                            [severity]="item['checkFlag'] ? 'danger': 'info'" styleClass="p-ml-1"></p-badge>
                    </div>
                </ng-container>
            </div>
            <div>
                <auth-button buttonId="drivers_add" type="button" label="新增" icon="pi pi-plus"
                    buttonClass="p-button-sm p-mr-2" (onClick)="editRes()"></auth-button>
                <!-- <auth-button buttonId="drivers_del" type="button" label="删除"
                    [disabled]="!selectedItem || !selectedItem.length" icon="pi pi-trash"
                    buttonClass="p-button-sm p-button-danger p-mr-2" (onClick)="delete()"></auth-button> -->
                <auth-button buttonId="export_driver_data" type="button" label="导出" icon="pi pi-cloud-download"
                    buttonClass="p-button-sm p-button-success p-mr-2" (onClick)="exportCheckExcel()"></auth-button>
                <auth-button buttonId="choose_driver_data" type="button" label="导入" icon="pi pi-cloud-download"
                    buttonClass="p-button-sm p-button-success p-mr-2" (onClick)="chooseExcel()"></auth-button>
                <!-- <auth-button buttonId="shipper_drivers" type="button" label="关联托运方"
                    [disabled]="!selectedItem || !selectedItem.length" icon="pi pi-plus"
                    buttonClass="p-button-sm p-button-success p-mr-2" (onClick)="relDriversDialog1()"></auth-button>
                <auth-button buttonId="agent_driver" type="button" label="关联区域合伙人"
                    [disabled]="!selectedItem || !selectedItem.length" icon="pi pi-plus"
                    buttonClass="p-button-sm p-button-success p-mr-2" (onClick)="relAgentDriver()"></auth-button>
                <auth-button type="button" buttonId="drivers_add" pRipple icon="pi pi-refresh"
                    [disabled]="!selectedItem || !selectedItem.length" label="同步授权" buttonClass="p-button-sm"
                    (onClick)="syncUserAuth()"></auth-button> -->
            </div>
        </div>
    </div>
    <div class="main-table" [ngStyle]="{overflow:listOfData.length == 0 ? 'hidden' : 'auto'}" *ngIf="changeTable">
        <p-table [value]="listOfData" styleClass="p-datatable-sm  p-datatable-gridlines" [resizableColumns]="true"
            columnResizeMode="expand" [@filterAnimation]="loadingNum" [scrollable]="true"
            [scrollable]="listOfData.length == 0 ? false: true" scrollHeight="flex" scrollHeight="flex"
            [(selection)]="selectedItem" [rowHover]="listOfData.length == 0 ? false : true" selectionMode="single"
            dataKey="id">
            <ng-template pTemplate="colgroup" let-columns>
                <colgroup>
                    <col style="width:50px">
                    <col style="width:36px">
                    <ng-container *ngFor="let key of keys;">
                        <col *ngIf="key.show" [style]="{width:key.width}" />
                    </ng-container>
                    <col style="width:420px">
                </colgroup>
            </ng-template>
            <ng-template pTemplate="header">
                <tr>
                    <th style="width:50px;text-align: center;" class="first frozenColumn pLeftFrozenColumn th">
                        序号
                    </th>
                    <th class="pLeftFrozenColumn frozenColumn th">
                        <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
                    </th>
                    <ng-container *ngFor="let key of keys;">
                        <th *ngIf="key.show" pResizableColumn class="th"
                            [class]="{'pLeftFrozenColumn': key.fix, 'frozenColumn': key.fix}"
                            style="text-align: center;">
                            {{key['label']}}
                        </th>
                    </ng-container>
                    <th class="right frozenColumn pRightFrozenColumn th">
                        操作
                    </th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-rowIndex="rowIndex" let-res>
                <tr [pSelectableRow]="res" [pSelectableRowIndex]="rowIndex">
                    <td style="width:50px;text-align: center;" class="first frozenColumn pLeftFrozenColumn td">
                        {{first+rowIndex+1}}
                    </td>
                    <td class="pLeftFrozenColumn frozenColumn td">
                        <p-tableCheckbox [value]="res"></p-tableCheckbox>
                    </td>
                    <ng-container *ngFor="let key of keys;">
                        <td *ngIf="key.show" pResizableColumn class="td"
                            [class]="{'pLeftFrozenColumn': key.fix, 'frozenColumn': key.fix}"
                            style="text-align: center;"
                            [ngStyle]="key['colorFormat'] ? keysFunction[key['key']].colorFormat(res[key['key']], res) : {}">
                            <ng-container *ngIf="key.keyTyps == 'detailLink'">
                                <a href="javascript:;" pRipple class="edit-font"
                                    (click)="showDriverDetail(res)">{{res[key['key']]}}</a>
                            </ng-container>
                            <ng-container *ngIf="key.keyTyps ==  'endUseDateLink'">
                                 <span [style]="{color:getDateDiffInDays(setCreateTime(res[key['key']] * 1000, 'yyyy-MM-dd')) < 0 ? 'red' : 'black'}">
                                   {{setCreateTime(res[key['key']] * 1000, "yyyy-MM-dd") }}
                                </span>
                                <span *ngIf="getDateDiffInDays(setCreateTime(res[key['key']] * 1000, 'yyyy-MM-dd')) < 30 && getDateDiffInDays(setCreateTime(res[key['key']] * 1000, 'yyyy-MM-dd')) > 0" style="color: red;">即将过期</span>
                                <span *ngIf="getDateDiffInDays(setCreateTime(res[key['key']] * 1000, 'yyyy-MM-dd')) < 0" style="color: red;">已过期</span>
                            </ng-container>
                             <ng-container *ngIf="key.keyTyps ==  'drivingEndUseDateLink'">
                                 <span [style]="{color:getDateDiffInDays(setCreateTime(res[key['key']] * 1000, 'yyyy-MM-dd')) < 0 ? 'red' : 'black'}">
                                    {{setCreateTime(res[key['key']] * 1000, "yyyy-MM-dd") }}
                                </span>
                                 <span *ngIf="getDateDiffInDays(setCreateTime(res[key['key']] * 1000, 'yyyy-MM-dd')) < 30 && getDateDiffInDays(setCreateTime(res[key['key']] * 1000, 'yyyy-MM-dd')) > 0" style="color: red;">即将过期</span>
                                 <span *ngIf="getDateDiffInDays(setCreateTime(res[key['key']] * 1000, 'yyyy-MM-dd')) < 0" style="color: red;">已过期</span>
                            </ng-container>
                             <ng-container *ngIf="key.keyTyps ==  'qualificationCertExpireTimeLink'">
                                <span [style]="{color:getDateDiffInDays(setCreateTime(res[key['key']] * 1000, 'yyyy-MM-dd')) < 0 ? 'red' : 'black'}">
                                   {{setCreateTime(res[key['key']] * 1000, "yyyy-MM-dd") }}
                                </span>
                                 <span *ngIf="getDateDiffInDays(setCreateTime(res[key['key']] * 1000, 'yyyy-MM-dd')) < 30 && getDateDiffInDays(setCreateTime(res[key['key']] * 1000, 'yyyy-MM-dd')) > 0" style="color: red;">即将过期</span>
                                   <span *ngIf="getDateDiffInDays(setCreateTime(res[key['key']] * 1000, 'yyyy-MM-dd')) < 0" style="color: red;">已过期</span>
                            </ng-container>
                            <ng-container *ngIf="key.keyTyps == 'tag'">
                                <p-tag
                                    [value]="key['format']?keysFunction[key['key']].format(res[key['key']], key) : res[key['key']]"
                                    [rounded]="true"
                                    [style]="{'background-color': keysFunction[key['key']].colorFormat(res[key['key']], key)}">
                                </p-tag>
                            </ng-container>
                            <ng-container *ngIf="key.keyTyps == 'detailTag'">
                                <p-tag
                                    (click)="showFacePhoto(res)"
                                    [value]="key['format']?keysFunction[key['key']].format(res[key['key']], key) : res[key['key']]"
                                    [rounded]="true"
                                    [style]="{'background-color': keysFunction[key['key']].colorFormat(res[key['key']], key)}">
                                </p-tag>
                            </ng-container>
                            <ng-container *ngIf="key.keyTyps == 'certificateExpiredTag'">
                                <span style="color: #008000;" *ngIf="res.certificateExpiredCount == 0">无过期</span>
                                <div style="color: red;" *ngIf="res.certificateExpiredCount != 0">
                                    <ng-container *ngIf="res.certificateExpiredIds.includes(',')">
                                        <span *ngFor="let item of res.certificateExpiredIds.split(',')" style="margin-left: 5px;margin-right: 5px;">
                                            {{item == 1 ? '身份证' : item == 2 ? '驾驶证' : item == 3 ? '从业资格证' : ''}}
                                        </span>
                                    </ng-container>
                                    <ng-container *ngIf="!res.certificateExpiredIds.includes(',')">
                                         {{res.certificateExpiredIds == 1 ? '身份证' : res.certificateExpiredIds == 2 ? '驾驶证' : res.certificateExpiredIds == 3 ? '从业资格证' : ''}}
                                    </ng-container>
                                </div>
                            </ng-container>
                            
                            <ng-container *ngIf="key['keyTyps'] == 'truckCount'">
                                <span [style]="{
                                    color: res[key['key']] > 0 ? '#00A600' : '#EA0000'
                                }" (click)="myCardRes(res)">
                                    {{res[key['key']]}}
                                </span>
                            </ng-container>
                            <!-- 图片地址展示 -->
                            <ng-container *ngIf="key.keyTyps == 'icon'">
                                <!-- 图片 -->
                                <img style="width: 100px; height: 80px;" [src]="res[key['key']]" alt="icon"
                                    (click)="previewThumbnailImage(res)">
                            </ng-container>
                            <!-- 时间格式 -->
                            <ng-container *ngIf="key.keyTyps == 'date'">
                                {{ change(res[key['key']],"yyyy-MM-dd") }}
                            </ng-container>

                            <ng-container *ngIf="!key.keyTyps">
                                {{ key['format'] ? keysFunction[key['key']].format(res[key['key']], key)
                                :res[key['key']] }}
                            </ng-container>
                        </td>
                    </ng-container>
                    <td class="right frozenColumn pRightFrozenColumn td" style="column-gap: 10px;">
                        <!-- <auth-button type="button" [isButton]=false buttonId="drivers_update" label="上报" pRipple
                            *ngIf="res.reportStatus==1" class="edit-font"
                            (click)="handleReport(res)"></auth-button> -->
                            <!-- <a  href="javascript:;" *ngIf="res.blacklistStatus!=1&&res.isOwner==1"
                           class="edit-font" style="margin-left: 5px;margin-right: 5px;"
                            (click)="bindC(res)">转为车主</a> -->
                            <a  href="javascript:;" *ngIf="res.blacklistStatus!=1 &&res.checkFlag !=2"
                           class="edit-font" style="margin-left: 5px;margin-right: 5px;"
                            (click)="editRes(res, 1)">修改</a>
                            <a  href="javascript:;" *ngIf="res.blacklistStatus!=1"
                           class="edit-font" style="margin-left: 5px;margin-right: 5px;"
                            (click)="myCardRes(res)">车辆</a>
                            <a  href="javascript:;" *ngIf="res.blacklistStatus!=1"
                           class="edit-font" style="margin-left: 5px;margin-right: 5px;"
                            (click)="myBankRes(res)">银行卡</a>
                            <a  href="javascript:;" *ngIf="res.blacklistStatus!=1"
                           class="edit-font" style="margin-left: 5px;margin-right: 5px;"
                            (click)="checkDriverFlag(res)">审核</a>
                            <a  href="javascript:;" *ngIf="res.blacklistStatus!=1"
                           class="edit-font" style="margin-left: 5px;margin-right: 5px;"
                            (click)="signContract(res)">签署</a>
                            <a  href="javascript:;" *ngIf="res.blacklistStatus != 1 && res.checkFlag == 2"
                           class="edit-font" style="margin-left: 5px;margin-right: 5px;"
                            (click)="authData(res)">{{noSignStatus[res['noSignStatus']]}}</a>
                            <a  href="javascript:;" *ngIf="res.blacklistStatus != 1 && res.checkFlag == 2"
                           class="edit-font" style="margin-left: 5px;margin-right: 5px;"
                            (click)="authUnbind(res)">解除授权</a>
                        <!-- <auth-button type="button" [isButton]=false buttonId="update_team" label="转为车主" pRipple
                            *ngIf="res.blacklistStatus!=1&&res.isOwner==1"
                            buttonClass="p-button-sm p-ml-2 p-button-outlined" (onClick)="insertTeam(res)">
                        </auth-button> -->
                        <!--<span type="button" class="edit-font" (click)="showAddMemberDialog(res)"
                            style="margin-right: 10px;">成为会员</span>-->
                        <!-- <auth-button type="button" [isButton]=false buttonId="drivers_update" label="修改" pRipple
                            *ngIf="res.blacklistStatus!=1 &&res.checkFlag !=2" class="edit-font"
                            (click)="editRes(res, 1)"></auth-button>
                        <auth-button type="button" [isButton]=false buttonId="truck_page" label="车辆" pRipple
                            *ngIf="res.blacklistStatus!=1" class="edit-font" (click)="myCardRes(res)"></auth-button>
                        <auth-button type="button" [isButton]=false buttonId="bank_page" label="银行卡" pRipple
                            *ngIf="res.blacklistStatus!=1" class="edit-font" (click)="myBankRes(res)"></auth-button>
                        <auth-button type="button" [isButton]=false buttonId="check" label="审核" pRipple
                            *ngIf="res.blacklistStatus!=1" class="edit-font"
                            (click)="checkDriverFlag(res)"></auth-button>
                        <auth-button type="button" [isButton]=false buttonId="drivers_update" label="签署" pRipple
                            *ngIf="res.blacklistStatus!=1" class="edit-font" (click)="signContract(res)"></auth-button>
                        <auth-button *ngIf="res.blacklistStatus != 1 && res.checkFlag == 2 " type="button"
                            [isButton]=false buttonId="drivers_update" pRipple
                            [label]="noSignStatus[res['noSignStatus']]" class="edit-font"
                            (click)="authData(res)"></auth-button>
                        <auth-button *ngIf="res.blacklistStatus != 1 && res.checkFlag == 2" type="button"
                            [isButton]=false buttonId="drivers_update" pRipple label="解除授权" class="edit-font"
                            (click)="authUnbind(res)"></auth-button> -->
                            <a  href="javascript:;" *ngIf="!res.sjUserId"
                           class="edit-font" style="margin-left: 5px;margin-right: 5px;"
                            (click)="bindC(res)">关联C端</a>
                             <a  href="javascript:;" *ngIf="res.sjUserId"
                           class="edit-font" style="margin-left: 5px;margin-right: 5px;"
                            (click)="unbindC(res)">解绑C端</a>
                    </td>
                </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
                <tr>
                    <!-- 2指初始化锁定列，复选框、操作，如果只有一种则改为1 -->
                    <td [attr.colspan]="getCurrentKeyLength(keys) + 2" style="text-align: center;border-bottom: 0;">
                        <div style="margin-top: 50px;width:calc(100vw - 240px);" [@emptyData]="emptyData">
                            <img class="emptyImg" src="assets/file/image/emptyData.png"
                                style="width:240px;height:240px;" />
                        </div>
                    </td>
                </tr>
            </ng-template>
        </p-table>
    </div>
    <div class="main-table" style="background-color: var(--surface-b-m);overflow-y: auto;" *ngIf="!changeTable"
        [@filterAnimation]="loadingNum">
        <div *ngIf="listOfData.length==0"
            style="width:100%;height:100%;align-items: center;text-align: center;padding-top: 100px;">
            <img class="emptyImg" src="assets/file/image/emptyData.png" style="width:240px;height:240px;" />
        </div>
        <div class="table-box" *ngFor="let item of listOfData">
            <div style="width:100%;height:100%;display:flex;align-items: center;"
                [class]="item.blacklistStatus==1 ? 'blacklist-line' : ''">
                <div style="position:absolute;left:0;top:0;">
                    <img *ngIf="item.blacklistStatus==1" src="assets/icon/blacklist.png" />
                </div>
                <div class="companyList-left">
                    <p-checkbox [value]="item" [(ngModel)]="selectedItem"></p-checkbox>
                </div>
                <div style="width:100%;">
                    <div class="box-top" style="margin-top:15px;">
                        <div class="box-top-left" class="p-display">
                            <div class="company-name edit-font p-mr-3" (click)="showDriverDetail(item)">
                                {{item['realname']}}
                            </div>
                            <img class="p-mr-3" *ngIf="item.politicalOutlook==1" src="assets/icon/party-emblem.png"
                                pTooltip="政治面貌：党员" tooltipPosition="top" alt="">
                            <img class="p-mr-3" *ngIf="item.sex==1" pTooltip="性别：男" tooltipPosition="top"
                                src="assets/icon/male.png" alt="">
                            <img class="p-mr-3" *ngIf="item.sex==0" pTooltip="性别：女" tooltipPosition="top"
                                src="assets/icon/female.png" alt="">

                            <img class="p-mr-3" *ngIf="item['source']==0" [pTooltip]="'来源：'+this.source[item['source']]"
                                tooltipPosition="top" src="assets/icon/pc.png" alt="">
                            <img class="p-mr-3" *ngIf="item['source']==1" [pTooltip]="'来源：'+this.source[item['source']]"
                                tooltipPosition="top" src="assets/icon/execl.png" alt="">
                            <img class="p-mr-3" *ngIf="item['source']==2" [pTooltip]="'来源：'+this.source[item['source']]"
                                tooltipPosition="top" src="assets/icon/wechat.png" alt="">
                            <img class="p-mr-3" *ngIf="item['source']==3" [pTooltip]="'来源：'+this.source[item['source']]"
                                tooltipPosition="top" src="assets/icon/mobile.png" alt="">

                            <div class="auditor p-mr-3" *ngIf="getAge(item['birthDate'])>0">
                                <span>{{getAge(item['birthDate'])}}周岁</span>
                            </div>
                            <div class="company-permit p-mr-3" *ngIf="getAge(item['birthDate'])>0 &&
                                    (getAge(item['birthDate'])<18 || getAge(item['birthDate'])>60)"
                                class="company-contract p-mr-3">
                                <span *ngIf="getAge(item['birthDate'])<18">年龄低于法定年限18周岁</span>
                                <span *ngIf="getAge(item['birthDate'])>60">年龄高于法定年限60周岁</span>
                            </div>

                            <div class="company-contract p-mr-3" *ngIf="item['signStatus']==0"
                                [pTooltip]="'委托代开协议签署状态：'+this.signStatus[item['signStatus']]" tooltipPosition="top">
                                {{this.signStatus[item['signStatus']]}}
                            </div>
                            <div class="company-status p-mr-3" *ngIf="item['signStatus']==1"
                                [pTooltip]="'委托代开协议签署状态：'+this.signStatus[item['signStatus']]" tooltipPosition="top">
                                {{this.signStatus[item['signStatus']]}}
                            </div>
                            <div class="company-success p-mr-3" *ngIf="item['signStatus']==2"
                                [pTooltip]="'委托代开协议签署状态：'+this.signStatus[item['signStatus']]" tooltipPosition="top"
                                (click)="showFadadaDriverAgree(item)">
                                {{this.signStatus[item['signStatus']]}}
                            </div>
                            <div class="company-permit p-mr-3" *ngIf="item['signStatus']==3"
                                [pTooltip]="'委托代开协议签署状态：'+this.signStatus[item['signStatus']]" tooltipPosition="top">
                                {{this.signStatus[item['signStatus']]}}
                            </div>

                            <div [class]="item['useStatus']==0 ? 'company-status p-mr-3' : 'company-permit p-mr-3'">
                                {{this.useStatus[item['useStatus']]}}</div>

                            <div class="company-contract p-mr-3"
                                *ngIf="getExpireDays(item['endUseDate'],'',item['expiredWarnDay']) > 0">
                                身份证{{getExpireDays(item['endUseDate'],'',item['expiredWarnDay'])}}天后过期</div>
                            <div class="company-permit p-mr-3"
                                *ngIf="getExpireDays(item['endUseDate'],'',item['expiredWarnDay']) < 0">
                                身份证已过期{{getExpireDays(item['endUseDate'],1,item['expiredWarnDay'])}}天</div>

                            <div class="company-contract p-mr-3"
                                *ngIf="getExpireDays(item['drivingEndUseDate'],'',item['expiredWarnDay']) > 0">
                                驾驶证{{getExpireDays(item['drivingEndUseDate'],'',item['expiredWarnDay'])}}天后过期</div>
                            <div class="company-permit p-mr-3"
                                *ngIf="getExpireDays(item['drivingEndUseDate'],'',item['expiredWarnDay']) < 0">
                                驾驶证已过期{{getExpireDays(item['drivingEndUseDate'],1,item['expiredWarnDay'])}}天</div>

                            <div class="company-contract p-mr-3"
                                *ngIf="getExpireDays(item['qualificationCertExpireTime'],'',item['expiredWarnDay']) > 0">
                                从业资格证{{getExpireDays(item['qualificationCertExpireTime'],'',item['expiredWarnDay'])}}天后过期
                            </div>
                            <div class="company-permit p-mr-3"
                                *ngIf="getExpireDays(item['qualificationCertExpireTime'],'',item['expiredWarnDay']) < 0">
                                从业资格证已过期{{getExpireDays(item['qualificationCertExpireTime'],1,item['expiredWarnDay'])}}天
                            </div>

                            <div class="company-permit p-mr-3" *ngIf="item['checkFlag'] == 3">不通过原因：{{item['checkLog']}}
                            </div>

                            <div class="company-status p-mr-3" *ngIf="item['isOwner'] == 2">车主
                            </div>
                        </div>
                        <div class="box-top-right p-display" style="padding-right: 50px;">
                            <div class="recentPosition p-mr-3">
                                <img src="assets/icon/map-location.png" alt="">&nbsp;
                                <span *ngIf="item.formattedAddress">
                                    {{item.formattedAddress}}
                                    <span class="auditor" [pTooltip]="'定位时间：'+this.setCreateTime(item['addTime']*1000)"
                                        tooltipPosition="top">（{{this.dateDiff(item['addTime']*1000)}}）</span>
                                </span>
                                <span class="auditor" *ngIf="!item.formattedAddress">暂无</span>
                            </div>
                            <ng-container *ngIf="item['checkFlag'] == 2 || item['checkFlag'] == 3">
                                <div class="auditor p-mr-3">审核人 : {{item['checkName']}}</div>
                                <div class="audit-time">审核时间 : {{this.setCreateTime(item['checkTime']*1000)}}</div>
                            </ng-container>
                        </div>
                        <div class="audit-status">
                            <img style="width: 60px; height: 60px;" *ngIf="item.checkFlag==1"
                                src="assets/icon/audit-status.png" alt="">
                            <img style="width: 60px; height: 60px;" *ngIf="item.checkFlag==2"
                                src="assets/icon/audit-status1.png" alt="">
                            <img style="width: 60px; height: 60px;" *ngIf="item.checkFlag==3"
                                src="assets/icon/audit-status2.png" alt="">
                        </div>
                    </div>
                    <div style="display:flex;align-items: center;">
                        <div class="td-box" style="margin:0;">
                            <ng-container *ngFor="let key of keys">
                                <div class="td-item" style="margin:0;"
                                    *ngIf="notPartKey.indexOf(',' + key.key + ',') == -1 && key.show">
                                    <label>{{key['label']}} : </label>
                                    <span
                                        [pTooltip]="key['format'] ? keysFunction[key['key']].format(item[key['key']], item):item[key['key']]"
                                        tooltipPosition="top">{{ key['format'] ?
                                        keysFunction[key['key']].format(item[key['key']], item):item[key['key']]
                                        }}</span>
                                </div>
                            </ng-container>
                        </div>
                        <div
                            style="width: auto; display: flex; align-items: center;margin-bottom:10px;margin-right: 25px;">
                            <div style="margin: 2px 0;">
                                <auth-button type="button" [isButton]=true buttonId="shipper_drivers" label="关联托运方"
                                    pRipple *ngIf="item.blacklistStatus!=1"
                                    buttonClass="p-button-sm p-ml-2 p-button-outlined"
                                    (onClick)="relDriversDialog(item)">
                                </auth-button>
                            </div>
                            <div style="margin: 2px 0;">
                                <auth-button type="button" [isButton]=true buttonId="agent_driver" label="关联区域合伙人"
                                    pRipple *ngIf="item.blacklistStatus!=1"
                                    buttonClass="p-button-sm p-ml-2 p-button-outlined"
                                    (onClick)="relAgentDriversDialog(item, 1)">
                                </auth-button>
                            </div>
                            <div style="margin: 2px 0;" *ngIf="item.isOwner==1">
                                <auth-button type="button" [isButton]=true buttonId="update_team" label="转为车主" pRipple
                                    *ngIf="item.blacklistStatus!=1" buttonClass="p-button-sm p-ml-2 p-button-outlined"
                                    (onClick)="insertTeam(item)">
                                </auth-button>
                            </div>
                            <div style="margin: 2px 0;">
                                <auth-button type="button" [isButton]=true buttonId="drivers_update" label="修改" pRipple
                                    *ngIf="item.blacklistStatus!=1 &&item.checkFlag!=2"
                                    buttonClass="p-button-sm p-ml-2 p-button-outlined" (onClick)="editRes(item, 1)">
                                </auth-button>
                            </div>
                            <div style="margin: 2px 0;">
                                <auth-button type="button" [isButton]=true buttonId="truck_page" label="车辆" pRipple
                                    *ngIf="item.blacklistStatus!=1" buttonClass="p-button-sm p-ml-2 p-button-outlined"
                                    (onClick)="myCardRes(item)">
                                </auth-button>
                            </div>
                            <div style="margin: 2px 0;">
                                <auth-button type="button" [isButton]=true buttonId="bank_page" label="银行卡" pRipple
                                    *ngIf="item.blacklistStatus!=1" buttonClass="p-button-sm p-ml-2 p-button-outlined"
                                    (onClick)="myBankRes(item)">
                                </auth-button>
                            </div>
                            <div style="margin: 2px 0;">
                                <auth-button type="button" [isButton]=true buttonId="check" label="审核" pRipple
                                    *ngIf="item.blacklistStatus!=1" buttonClass="p-button-sm p-ml-2 p-button-outlined"
                                    (onClick)="checkDriverFlag(item)">
                                </auth-button>
                            </div>
                            <div style="margin: 2px 0;">
                                <auth-button type="button" [isButton]=true buttonId="check" label="签署" pRipple
                                    *ngIf="item.blacklistStatus!=1" buttonClass="p-button-sm p-ml-2 p-button-outlined"
                                    (onClick)="signContract(item)">
                                </auth-button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <p-paginator showCurrentPageReport=true [first]="first"
        currentPageReportTemplate="共 {totalRecords} 条记录 第 {currentPage} / {totalPages} 页 " [rows]="defaultRows"
        [rowsPerPageOptions]="defaultRowsPerPage" pageLinkSize="3" [totalRecords]="totalNum" styleClass="p-paginator-sm"
        (onPageChange)="queryList($event)"></p-paginator>
</div>

<!-- 成为会员 -->
<p-dialog class="edit-data" [(visible)]="addMemberDialog" [modal]="false" [style]="{width: '450px'}" [draggable]="true"
    [resizable]="false" (onHide)="editStep = 0" [keepInViewport]="false" *ngIf="addMemberDialog"
    (onShow)="dialogBlock = true">
    <ng-template pTemplate="header">
        <div class="p-dialog-title">
            成为会员
        </div>
    </ng-template>
    <form [formGroup]="memberValidateForm">

        <div class="p-field p-grid">
            <label for="level" class="p-col-fixed" style="width:100px">会员生效时间</label>
            <div class="p-col">
                <p-calendar formControlName="effectTime" class="p-inputtext-sm" dateFormat="yy-mm-dd" appendTo="body"
                    [style]="{'width':'100%'}" [readonlyInput]="true" dataType="string"></p-calendar>
            </div>
        </div>

        <div class="p-field p-grid">
            <label for="level" class="p-col-fixed" style="width:100px">会员等级</label>
            <div class="p-col">
                <p-dp-detail [options]="levelList" formControlName="level" emptyMessage="未查询到数据"
                    (onChange)="valueLevelChange($event)" emptyFilterMessage="未查询到数据"
                    class="p-mr-2 p-d-inline p-inputtext-sm" id="level" appendTo="body" filter="true"
                    [style]="{'width':'100%'}">
                </p-dp-detail>
            </div>
        </div>

        <div class="p-field p-grid">
            <label for="realPrice" class="p-col-fixed" style="width:100px">付款金额</label>
            <div class="p-col">
                <input id="realPrice" type="text" pInputText formControlName="realPrice" [style]="{width: '100%'}">
                <small *ngIf="checkFormItem(this.memberValidateForm, 'realPrice')" class="p-error block error-msg">
                    请填写付款金额
                </small>
            </div>
        </div>

        <div class="p-field p-grid">
            <label for="salesman" class="p-col-fixed" style="width:100px">业务员</label>
            <div class="p-col">
                <p-dp-detail [options]="salesmanList" formControlName="salesman" emptyMessage="未查询到数据"
                    emptyFilterMessage="未查询到数据" class="p-mr-2 p-d-inline p-inputtext-sm" id="salesman" appendTo="body"
                    filter="true" [style]="{'width':'100%'}">
                </p-dp-detail>
            </div>
        </div>

    </form>
    <ng-template pTemplate="footer">
        <p-button icon="pi pi-check" (click)="addMemberLevel(res)" label="确定" class="p-button-text"></p-button>
        <button pButton pRipple icon="pi pi-times" type="button" label="取消"
            (click)="addMemberDialog = false || dialogBlock = false"
            class="p-button-raised p-button-text p-button-plain"></button>
    </ng-template>
</p-dialog>
<!-- 成为会员 -->

<!--验证司机开始-->
<p-dialog [(visible)]="editDriverIdCardDialogFlag" [modal]="false" class='edit-data' *ngIf="editDriverIdCardDialogFlag"
    [style]="{width: dialog_width_small}" [draggable]="true" [resizable]="false" [keepInViewport]="false"
    (onShow)="editUploadIdCard.clear() || (identifyIdCardFrontUrl = 'assets/file/image/sfzFront.png')"
    (onShow)="dialogBlock = true">
    <ng-template pTemplate="header">
        <div class="p-dialog-title">
            司机验证
        </div>
        <button type="button" [ngClass]="{ 'p-dialog-header-icon p-dialog-header-close p-link': true }"
            (click)="dialogBlock = false || editDriverIdCardDialogFlag = false" pRipple>
            <span class="p-dialog-header-close-icon" class="pi pi-times"></span>
        </button>
    </ng-template>
    <form [formGroup]="validateFormPhone" style="width:100%;padding:24px 16px 0 16px;">
        <div class="p-field upload-photo-box" [style]="{backgroundImage: 'url(' + identifyIdCardFrontUrl + ')'}">
            <span class="upload-photo upload-photo-span">
                <p-fileUpload #editUploadIdCard mode="basic" (onSelect)="identifyCard($event)" chooseLabel=""
                    [fileLimit]="1" accept="image/*"
                    [style]="{'zIndex':'10',opacity:'0',width: '100%', height: '200px'}" maxFileSize="32*1048*1048">
                </p-fileUpload>
            </span>
            <!-- 删除按钮 -->
            <a *ngIf="identifyIdCardFrontUrl != 'assets/file/image/sfzFront.png'" class="upload-photo-a"
                href="javascript:;" pRipple
                (click)="editUploadIdCard.clear() || (identifyIdCardFrontUrl = 'assets/file/image/sfzFront.png')">
                <i class="pi pi-trash"></i>
            </a>
        </div>
        <div class="p-field p-grid">
            <label for="idCardNo" class="p-col-fixed" style="width:90px;">身份证号:</label>
            <div class="p-col">
                <p-inputMask id="idCardNo" formControlName="idCardNo" [style]="{width: '100%'}"
                    mask="999 999 9999 9999 999*" placeholder="请填写身份证号码" characterPattern="[*X]"></p-inputMask>
                <!-- <input id="idCardNo" type="text" pInputText formControlName="idCardNo" style="width:100%;"> -->
                <!-- <small *ngIf="checkFormItem(this.validateFormPhone, 'idCardNo')" class="p-error block error-msg">
                    请上传身份证头像面照片
                </small> -->
            </div>
        </div>
        <div class="p-field p-grid">
            <label for="sjUserId" class="p-col-fixed" style="width:90px;">C端手机号:</label>
            <div class="p-col">
                <p-dp-detail
                    [style]="{width: '100%'}"
                    [options]="mobilePhoneList"
                    formControlName="sjUserId"
                    placeholder="请填写手机号"
                    filter="false"
                    id="sjUserId"
                    appendTo="body"
                    (onFilter)="searchMobilePhone($event)"
                >
                </p-dp-detail>
            </div>
        </div>
    </form>
    <ng-template pTemplate="footer">
        <button pButton pRipple icon="pi pi-check" type="button"
            [disabled]="photoUrl == '' && this.validateFormPhone.controls.idCardNo.value =='' " (click)="queryDriver()"
            label="下一步" class="p-button-raised"></button>
        <button pButton pRipple icon="pi pi-times" type="button" label="取消"
            (click)="editDriverIdCardDialogFlag = false|| dialogBlock = false"
            class="p-button-raised p-button-text p-button-plain"></button>
    </ng-template>
</p-dialog>
<!--验证司机结束-->

<p-dialog [(visible)]="showAuthDialog" [modal]="false" [style]="{width: dialog_width_middle}" [draggable]="true"
    [keepInViewport]="false" [resizable]="false" *ngIf="showAuthDialog" (onShow)="dialogBlock = true">
    <ng-template pTemplate="header">
        <div class="p-dialog-title">
            签署二维码
        </div>
        <button type="button" [ngClass]="{ 'p-dialog-header-icon p-dialog-header-close p-link': true }"
            (click)="dialogBlock = false || showAuthDialog = false" pRipple>
            <span class="p-dialog-header-close-icon" class="pi pi-times"></span>
        </button>
    </ng-template>
    <div class="qrcode" id="qrcode" style="padding: 30px 0 20px 0;">
        <div class="qCode-body">
            <div style="display: flex;justify-content: center;align-items: center;">
                <ngx-qrcode style="padding: 10px" [elementType]="elementType" [value]="qCodeValue"
                    [errorCorrectionLevel]="correctionLevel" [width]="250">
                </ngx-qrcode>
            </div>
        </div>
    </div>
    <div id="qrcodeimg"></div>
</p-dialog>

<!-- 签署委托代征 -->
<p-dialog [(visible)]="signContractDialog" [modal]="false" [style]="{width: dialog_width_small}"
    *ngIf="signContractDialog" class="edit-data" [draggable]="true" [resizable]="false" [keepInViewport]="false"
    (onShow)="dialogBlock = true">
    <ng-template pTemplate="header">
        <div class="p-dialog-title">
            签署
        </div>
        <button type="button" [ngClass]="{ 'p-dialog-header-icon p-dialog-header-close p-link': true }"
            (click)="dialogBlock = false || signContractDialog = false" pRipple>
            <span class="p-dialog-header-close-icon" class="pi pi-times"></span>
        </button>
    </ng-template>
    <form [formGroup]="signContractForm" style="width:100%;padding:24px 16px 0 16px;">
        <div class="p-field p-grid" *ngIf="this.fddSignFlag==true">
            <label for="sign_with_message" class="p-col-fixed" style="width:120px">签署状态:</label>
            <label for="sign_with_message" class="p-col-fixed" style="width:120px" style="color: #B15BFF;"
                *ngIf="this.fddDetail['signStatus']==1">签署中</label>
            <label for="sign_with_message" class="p-col-fixed" style="width:120px"
                (click)="showFadadaDriverAgree(this.fddDetail)" style="color: #00A600;cursor:pointer;"
                *ngIf="this.fddDetail['signStatus']==2">已签署</label>
            <label for="sign_with_message" class="p-col-fixed" style="width:120px" style="color: #f01313;"
                *ngIf="this.fddDetail['signStatus']==3">签署失败</label>
        </div>
        <div class="p-field p-grid" *ngIf="this.fddSignFlag==true">
            <label for="sign_with_message" class="p-col-fixed" style="width:120px">签署时间:</label>
            <label for="sign_with_message" class="p-col-fixed"
                style="width:170px">{{this.setCreateTime(this.fddDetail['createTime']*1000)}}</label>
        </div>
        <div class="p-field p-grid">
            <label for="sign_with_message" class="p-col-fixed" style="width:120px">签署方式:</label>
            <p-radioButton name="signContract" value="1" class="p-mr-2" inputId="sign_with_message"
                formControlName="signContract">
            </p-radioButton>
            <label for="sign_with_code" class="p-mr-3">简码签署</label>
            <p-radioButton name="signContract" value="2" class="p-mr-2" inputId="sign_with_code"
                formControlName="signContract">
            </p-radioButton>
            <label class="p-mr-3">短信签署</label>
        </div>
    </form>
    <ng-template pTemplate="footer">
        <button pButton pRipple icon="pi pi-check" type="button" (click)="saveSignContract()" label="签署"
            class="p-button-raised"></button>
        <button pButton pRipple icon="pi pi-times" type="button" label="取消"
            (click)="signContractDialog = false || dialogBlock = false"
            class="p-button-raised p-button-text p-button-plain"></button>
    </ng-template>
</p-dialog>

<!-- 显示签署二维码 -->
<p-dialog [modal]="false" [(visible)]="showQCodeFlag" [style]="{width: '470px', textAlign:'center'}"
    *ngIf="showQCodeFlag" (onShow)="dialogBlock = true" [draggable]="true" [keepInViewport]="false">
    <ng-template pTemplate="header">
        <div class="p-dialog-title">
            委托代征协议签署二维码
        </div>
        <button type="button" [ngClass]="{ 'p-dialog-header-icon p-dialog-header-close p-link': true }"
            (click)="dialogBlock = false || showQCodeFlag = false" pRipple>
            <span class="p-dialog-header-close-icon" class="pi pi-times"></span>
        </button>
    </ng-template>
    <!-- <ng-template pTemplate="header">
        <span style="font-weight: 600;font-size: large;margin-right:20px;">
            委托代征协议签署二维码
        </span>
    </ng-template> -->
    <div class="qrcode" id="qrcode" style="padding: 30px 0 20px 0;">
        <div class="qCode-body">
            <div style="display: flex;justify-content: center;align-items: center;">
                <ngx-qrcode style="padding: 10px" [elementType]="elementType" [value]="qCodeValue"
                    [errorCorrectionLevel]="correctionLevel" [width]="250">
                </ngx-qrcode>
            </div>
        </div>
    </div>
    <div id="qrcodeimg"></div>
</p-dialog>


<!-- 编辑司机开始 -->
<p-dialog [(visible)]="editDialogFlag" [modal]="false" [style]="{width: '1000px'}" *ngIf="editDialogFlag"
    class="edit-data" [draggable]="true" [resizable]="false" [keepInViewport]="false" (onShow)="dialogBlock = true">
    <ng-template pTemplate="header">
        <div class="p-dialog-title">
            司机编辑
        </div>
        <button type="button" [ngClass]="{ 'p-dialog-header-icon p-dialog-header-close p-link': true }"
            (click)="dialogBlock = false || editDialogFlag = false" pRipple>
            <span class="p-dialog-header-close-icon" class="pi pi-times"></span>
        </button>
    </ng-template>
    <form [formGroup]="validateForm" style="width:100%;padding:0px 16px 0 16px;">
        <div class="p-fluid filed-body" style="overflow-x:hidden;">
            <div class="p-field p-grid">
                <div class="p-md-6 field-item">
                    <div class="p-display upload-file-box">
                        <div class="p-display ">
                            <div class="p-mr-3">
                                <img [src]="idCardFrontUrl" image-viewer (click)="priviewImgs(idCardFrontUrl)"
                                    class="upload-file-back" />
                            </div>
                            <div>
                                <div style="font-size:large;font-weight:700;">
                                    身份证头像面(可拖拽)<span class="label-sel">*</span>
                                </div>
                                <div>
                                    请上传身份证头像面扫描件或数码照，支持jpg,jpeg,png格式照片
                                </div>
                            </div>
                        </div>
                        <div>
                            <div class="upload-photo-box" [style]="{width: '100px', height: '30px'}">
                                <span class="upload-photo upload-photo-span"
                                    style="width: '100px'; height: '30px';z-index: 5;">
                                    <p-fileUpload #idCardFrontFileUpload mode="basic" chooseLabel=""
                                        (onSelect)="onSelectIdcard($event)" [fileLimit]="1" accept="image/*"
                                        multiple="multiple"
                                        [style]="{'zIndex': '10',opacity:'0',width: '340px', height: '75px',right: '250px',bottom: '23px'}"
                                        maxFileSize="32*1048*1048"></p-fileUpload>
                                </span>
                                <span class="upload-photo upload-photo-span"
                                    style="width: '100px'; height: '30px';z-index: 2;">
                                    <button pButton pRipple type="button"
                                        [label]="idCardFrontUrl=='assets/file/image/id-card-front.png' ? '点击上传' : '重新上传'"
                                        class="p-button-sm" icon="pi pi-cloud-upload"
                                        [style]="{'width':'100px'}"></button>
                                    <input #idCardFrontInput type="hidden" (click)="idCardFrontFileUpload.clear()" />
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="p-md-6 field-item">
                    <div class="p-display upload-file-box">
                        <div class="p-display">
                            <div class="p-mr-3">
                                <img [src]="idCardBackUrl" image-viewer (click)="priviewImgs(idCardBackUrl)"
                                    class="upload-file-back" />
                            </div>
                            <div>
                                <div style="font-size:large;font-weight:700;">
                                    身份证国徽面<span class="label-sel">*</span>
                                </div>
                                <div>
                                    请上传身份证国徽面扫描件或数码照，支持jpg,jpeg,png格式照片
                                </div>
                            </div>
                        </div>
                        <div>
                            <div class="upload-photo-box" [style]="{width: '100px', height: '30px'}">
                                <span class="upload-photo upload-photo-span"
                                    style="width: '100px'; height: '30px';z-index: 5;">
                                    <p-fileUpload #idCardBackFileUpload mode="basic" chooseLabel=""
                                        (onSelect)="onSelectIdCardBack($event)" [fileLimit]="1" accept="image/*"
                                        multiple="multiple"
                                        [style]="{'zIndex': '10',opacity:'0',width: '340px', height: '75px',right: '250px',bottom: '23px'}"
                                        maxFileSize="32*1048*1048"></p-fileUpload>
                                </span>
                                <span class="upload-photo upload-photo-span"
                                    style="width: '100px'; height: '30px';z-index: 2;">
                                    <button pButton pRipple type="button"
                                        [label]="idCardBackUrl=='assets/file/image/id-card-back.png' ? '点击上传':'重新上传'"
                                        class="p-button-sm" icon="pi pi-cloud-upload"
                                        [style]="{'width':'100px'}"></button>
                                    <input #idCardBackInput type="hidden" (click)="idCardBackFileUpload.clear()" />
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="p-md-6 filed-item">
                    <div class="p-display upload-file-box">
                        <div class="p-display">
                            <div class="p-mr-3">
                                <img [src]="drivingLicensePhotoUrl" image-viewer
                                    (click)="priviewImgs(drivingLicensePhotoUrl)" class="upload-file-back" />
                            </div>
                            <div>
                                <div style="font-size:large;font-weight:700;">
                                    驾驶证主页<span class="label-sel">*</span>
                                </div>
                                <div>
                                    请上传司机驾驶证主页扫描件或数码照，支持jpg,jpeg,png格式照片
                                </div>
                            </div>
                        </div>
                        <div>
                            <div class="upload-photo-box" [style]="{width: '100px', height: '30px'}">
                                <span class="upload-photo upload-photo-span"
                                    style="width: '100px'; height: '30px';z-index: 5;">
                                    <p-fileUpload #drivingLicensePhotoFileUpload mode="basic" chooseLabel=""
                                        (onSelect)="onSelectBusiness($event)" [fileLimit]="1" accept="image/*"
                                        multiple="multiple"
                                        [style]="{'zIndex': '10',opacity:'0',width: '340px', height: '75px',right: '250px',bottom: '23px'}"
                                        maxFileSize="32*1048*1048"></p-fileUpload>
                                </span>
                                <span class="upload-photo upload-photo-span"
                                    style="width: '100px'; height: '30px';z-index: 2;">
                                    <button pButton pRipple type="button"
                                        [label]="drivingLicensePhotoUrl=='assets/file/image/xsz.png' ? '点击上传':'重新上传'"
                                        class="p-button-sm" icon="pi pi-cloud-upload"
                                        [style]="{'width':'100px'}"></button>
                                    <input #drivingLicensePhotoInput type="hidden"
                                        (click)="drivingLicensePhotoFileUpload.clear()" />
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="p-md-6 filed-item">
                    <div class="p-display upload-file-box">
                        <div class="p-display">
                            <div class="p-mr-3">
                                <img [src]="drivingLicenseBackPhotoUrl" image-viewer
                                    (click)="priviewImgs(drivingLicenseBackPhotoUrl)" class="upload-file-back" />
                            </div>
                            <div>
                                <div style="font-size:large;font-weight:700;">
                                    驾驶证副页<span class="label-sel">*</span>
                                </div>
                                <div>
                                    请上传司机驾驶证副页扫描件或数码照，支持jpg,jpeg,png格式照片
                                </div>
                            </div>
                        </div>
                        <div>
                            <div class="upload-photo-box" [style]="{width: '100px', height: '30px'}">
                                <span class="upload-photo upload-photo-span"
                                    style="width: '100px'; height: '30px';z-index: 5;">
                                    <p-fileUpload #drivingLicenseBackPhotoFileUpload mode="basic" chooseLabel=""
                                        (onSelect)="onSelectDrivingLicenseBack($event)" [fileLimit]="1" accept="image/*"
                                        multiple="multiple"
                                        [style]="{'zIndex': '10',opacity:'0',width: '340px', height: '75px',right: '250px',bottom: '23px'}"
                                        maxFileSize="32*1048*1048"></p-fileUpload>
                                </span>
                                <span class="upload-photo upload-photo-span"
                                    style="width: '100px'; height: '30px';z-index: 2;">
                                    <button pButton pRipple type="button"
                                        [label]="drivingLicenseBackPhotoUrl=='assets/file/image/xsz.png' ? '点击上传':'重新上传'"
                                        class="p-button-sm" icon="pi pi-cloud-upload"
                                        [style]="{'width':'100px'}"></button>
                                    <input #drivingLicenseBackPhotoInput type="hidden"
                                        (click)="drivingLicenseBackPhotoFileUpload.clear()" />
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="p-md-6 filed-item">
                    <div class="p-display upload-file-box">
                        <div class="p-display">
                            <div class="p-mr-3">
                                <img [src]="qualificationCertPhotoUrl" image-viewer
                                    (click)="priviewImgs(qualificationCertPhotoUrl)" class="upload-file-back" />
                            </div>
                            <div>
                                <div style="font-size:large;font-weight:700;">
                                    从业资格证<span class="label-sel">*</span>
                                </div>
                                <div>
                                    请上传司机从业资格证扫描件或数码照，支持jpg,jpeg,png格式照片
                                </div>
                            </div>
                        </div>
                        <div>
                            <div class="upload-photo-box" [style]="{width: '100px', height: '30px'}">
                                <span class="upload-photo upload-photo-span"
                                    style="width: '100px'; height: '30px';z-index: 5;">
                                    <p-fileUpload #qualificationCertPhotoFileUpload mode="basic" chooseLabel=""
                                        (onSelect)="onSelectQualificationCert($event)" [fileLimit]="1" accept="image/*"
                                        multiple="multiple"
                                        [style]="{'zIndex': '10',opacity:'0',width: '340px', height: '75px',right: '250px',bottom: '23px'}"
                                        maxFileSize="32*1048*1048"></p-fileUpload>
                                </span>
                                <span class="upload-photo upload-photo-span"
                                    style="width: '100px'; height: '30px';z-index: 2;">
                                    <button pButton pRipple type="button"
                                        [label]="qualificationCertPhotoUrl=='assets/file/image/xsz.png' ? '点击上传':'重新上传'"
                                        class="p-button-sm" icon="pi pi-cloud-upload"
                                        [style]="{'width':'100px'}"></button>
                                    <input #qualificationCertPhotoInput type="hidden"
                                        (click)="qualificationCertPhotoFileUpload.clear()" />
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="p-field p-grid">
                <div class="p-field p-col-6 p-md-12 edit-sel"
                    style="font-weight: 700;font-size:18px;color: var(--text-color);">基本信息</div>
                <div class="p-field p-col-6 p-md-3 edit-sel">
                    <label for="realname">司机姓名
                        <span class="label-sel">*</span>
                    </label>
                    <div class="filed-input">
                        <input id="realname" type="text" pInputText formControlName="realname"
                            class="p-inputtext-sm p-text-value">
                    </div>
                    <small *ngIf="checkFormItem(this.validateForm, 'realname')" class="p-error block error-msg">
                        请填写司机姓名
                    </small>
                </div>
                <div class="p-field p-col-6 p-md-3 edit-sel">
                    <label for="mobilePhone">手机号
                        <span class="label-sel">*</span>
                    </label>
                    <div class="filed-input">
                        <p-inputMask id="mobilePhone" formControlName="mobilePhone" [style]="{width: '100%'}"
                            class="p-inputtext-sm p-text-value cus_input" mask="999 9999 9999"></p-inputMask>
                    </div>
                    <small *ngIf="checkFormItem(this.validateForm, 'mobilePhone')" class="p-error block error-msg">
                        请填写正确格式手机号
                    </small>
                </div>
                <div class="p-field p-col-6 p-md-3 edit-sel">
                    <label for="politicalOutlook">政治面貌
                        <span class="label-sel">*</span>
                    </label>
                    <p-dp-detail [options]="politicalOutlookLists" formControlName="politicalOutlook"
                        id="politicalOutlook" appendTo="body" class="p-inputtext-sm p-text-value">
                    </p-dp-detail>
                    <small *ngIf="checkFormItem(this.validateForm, 'politicalOutlook')" class="p-error block error-msg">
                        请选择政治面貌
                    </small>
                </div>
                <div class="p-field p-col-6 p-md-3 edit-sel">
                    <label for="sex">性别</label>
                    <div class="filed-input">
                        <p-radioButton required name="sex" value="1" formControlName="sex"></p-radioButton>
                        &nbsp;
                        <label class="deposit">男</label>
                        &nbsp;
                        <p-radioButton required name="sex" value="0" formControlName="sex"></p-radioButton>
                        &nbsp;
                        <label class="fdeposit">女</label>
                        <small *ngIf="checkFormItem(this.validateForm, 'sex')" class="p-error block error-msg">
                            请填写性别
                        </small>
                    </div>
                </div>
                <div class="p-field p-col-6 p-md-3 edit-sel">
                    <label for="birthDate">出生年月</label>
                    <div class="filed-input">
                        <p-calendar formControlName="birthDate" id="birthDate" class="p-inputtext-sm p-text-value"
                            dateFormat="yy-mm-dd" dataType="string" appendTo="body">
                        </p-calendar>
                    </div>
                </div>
                <div class="p-field p-col-6 p-md-3 edit-sel">
                    <label for="idCardNo">身份证号
                        <span class="label-sel">*</span>
                    </label>
                    <div class="filed-input">
                        <p-inputMask id="idCardNo" formControlName="idCardNo" [style]="{width: '100%'}"
                            mask="999 999 9999 9999 999*" characterPattern="[*X]" class="p-inputtext-sm p-text-value">
                        </p-inputMask>
                    </div>
                    <small *ngIf="checkFormItem(this.validateForm, 'idCardNo')" class="p-error block error-msg">
                        请填写身份证号
                    </small>
                </div>
                <div class="p-field p-col-6 p-md-6 edit-sel">
                    <label for="address">住址
                        <span class="label-sel">*</span>
                    </label>
                    <div class="filed-input">
                        <input id="address" type="text" pInputText formControlName="address"
                            class="p-inputtext-sm p-text-value">
                    </div>
                    <small *ngIf="checkFormItem(this.validateForm, 'address')" class="p-error block error-msg">
                        请填写住址
                    </small>
                </div>
                <div class="p-field p-col-6 p-md-3 edit-sel">
                    <label for="startUseDate">身份证有效期起
                        <span class="label-sel">*</span>
                    </label>
                    <div class="filed-input">
                        <p-calendar formControlName="startUseDate" id="startUseDate" class="p-inputtext-sm p-text-value"
                            dateFormat="yy-mm-dd" dataType="string" appendTo="body"></p-calendar>
                    </div>
                </div>
                <div class="p-field p-col-6 p-md-3 edit-sel">
                    <label for="endUseDate">身份证有效期止
                        <span class="label-sel">*</span>
                    </label>
                    <div class="filed-input">
                        <p-calendar formControlName="endUseDate" id="endUseDate" class="p-inputtext-sm p-text-value"
                            dateFormat="yy-mm-dd" dataType="string" appendTo="body">
                        </p-calendar>
                    </div>
                </div>
                <div class="p-field p-col-6 p-md-3 edit-sel">
                    <label for="qualificationCertNo">从业资格证号
                        <span class="label-sel">*</span>
                    </label>
                    <div class="filed-input">
                        <input id="qualificationCertNo" type="text" pInputText formControlName="qualificationCertNo"
                            class="p-inputtext-sm p-text-value">
                        <small *ngIf="checkFormItem(this.validateForm, 'qualificationCertNo')"
                            class="p-error block error-msg">
                            请填写从业资格证
                        </small>
                    </div>
                </div>
                  <div class="p-field p-col-6 p-md-3 edit-sel">
                    <label for="qualificationCertExpireTime">从业资格证失效日期
                        <!-- <span class="label-sel">*</span> -->
                    </label>
                    <div class="filed-input">
                        <p-calendar inputId="qualificationCertExpireTime" formControlName="qualificationCertExpireTime"
                            dateFormat="yy-mm-dd" class="p-inputtext-sm p-text-value" appendTo="body" dataType="string"
                            [inputStyle]="{fontWeight: 'bold'}"></p-calendar>
                        <!-- <small *ngIf="checkFormItem(this.validateForm, 'qualificationCertExpireTime')"
                            class="p-error block error-msg">
                            请选择从业资格证失效日期
                        </small> -->
                    </div>
                </div>
                <div class="p-field p-col-6 p-md-3 edit-sel">
                    <label for="insureProvince" style="white-space: nowrap;">从业资格证颁发机构所在地（省） <span class="label-sel">*</span></label>
                    <div class="filed-input">
                        <p-dp-detail [options]="insProvinceList" formControlName="insureProvince" filter="false"
                            id="insureProvince" appendTo="body" class="p-inputtext-sm"
                            (onChange)="changeinsProvinceList($event)">
                        </p-dp-detail>
                        <small *ngIf="checkFormItem(this.validateForm, 'insureProvince')"
                            class="p-error block error-msg">
                            请选择从业资格证颁发机构所在地
                        </small>
                    </div>
                </div>
                <div class="p-field p-col-6 p-md-3 edit-sel">
                    <label for="qualificationCertIssueAreaCode" style="white-space: nowrap;">从业资格证颁发机构所在地（市） <span class="label-sel">*</span></label>
                    <div class="filed-input">
                        <p-dp-detail [options]="insCityList" formControlName="qualificationCertIssueAreaCode" filter="false" id="qualificationCertIssueAreaCode"
                        appendTo="body" class="p-inputtext-sm">
                    </p-dp-detail>
                        <small *ngIf="checkFormItem(this.validateForm, 'qualificationCertIssueAreaCode')"
                            class="p-error block error-msg">
                            请选择从业资格证颁发机构所在地
                        </small>
                    </div>
                </div>
              

                <div class="p-field p-col-6 p-md-12 edit-sel"
                    style="font-weight: 700;font-size:18px;color: var(--text-color);">驾驶证信息</div>
                <div class="p-field p-col-6 p-md-3 edit-sel">
                    <label for="driverType">准驾车型
                        <span class="label-sel">*</span>
                    </label>
                    <div class="filed-input">
                        <p-dp-detail [options]="driverTypeList" formControlName="driverType" filter="true"
                            id="driverType" appendTo="body" class="p-inputtext-sm p-text-value">
                        </p-dp-detail>
                    </div>
                    <small *ngIf="checkFormItem(this.validateForm, 'driverType')" class="p-error block error-msg">
                        请选择准驾车型
                    </small>
                </div>
                <div class="p-field p-col-6 p-md-3 edit-sel">
                    <label for="drivingLicenseNo">档案编号
                        <span class="label-sel">*</span>
                    </label>
                    <div class="filed-input">
                        <input id="drivingLicenseNo" type="text" pInputText formControlName="drivingLicenseNo"
                            class="p-inputtext-sm p-text-value">
                    </div>
                    <small *ngIf="checkFormItem(this.validateForm, 'drivingLicenseNo')" class="p-error block error-msg">
                        请输入档案编号
                    </small>
                </div>
                <div class="p-field p-col-6 p-md-3 edit-sel">
                    <label for="drivingStartUseDate">驾驶证有效期起
                        <span class="label-sel">*</span>
                    </label>
                    <div class="filed-input">
                        <p-calendar inputId="drivingStartUseDate" formControlName="drivingStartUseDate"
                            dateFormat="yy-mm-dd" class="p-inputtext-sm p-text-value" appendTo="body" dataType="string"
                            [inputStyle]="{fontWeight: 'bold'}"></p-calendar>
                    </div>
                    <small *ngIf="checkFormItem(this.validateForm, 'drivingStartUseDate')"
                        class="p-error block error-msg">
                        请选择驾驶证有效期起
                    </small>
                </div>
                <div class="p-field p-col-6 p-md-3 edit-sel">
                    <label for="drivingEndUseDate">驾驶证有效期止
                        <span class="label-sel">*</span>
                    </label>
                    <div class="filed-input">
                        <p-calendar inputId="drivingEndUseDate" formControlName="drivingEndUseDate"
                            dateFormat="yy-mm-dd" class="p-inputtext-sm p-text-value" appendTo="body" dataType="string"
                            [inputStyle]="{fontWeight: 'bold'}"></p-calendar>
                        <small *ngIf="checkFormItem(this.validateForm, 'endUseDate')" class="p-error block error-msg">
                            请选择驾驶证有效期止
                        </small>
                    </div>
                </div>
                <div class="p-field p-col-6 p-md-3 edit-sel">
                    <label for="issuingOrganizations">驾驶证发证机关</label>
                    <div class="filed-input">
                        <input id="issuingOrganizations" type="text" pInputText formControlName="issuingOrganizations"
                            class="p-inputtext-sm p-text-value">
                    </div>
                </div>
                <div class="p-field p-col-6 p-md-6 edit-sel">
                    <label for="remark">备注</label>
                    <div class="filed-input">
                        <input id="remark" type="text" pInputText formControlName="remark"
                            class="p-inputtext-sm p-text-value">
                    </div>
                </div>
            </div>
        </div>
    </form>
    <ng-template pTemplate="footer">
        <p-button icon="pi pi-check" *ngIf="editDialogType == 1" (click)="save()" label="保存" class="p-button-text">
        </p-button>
        <p-button icon="pi pi-check" *ngIf="editDialogType == 2" (click)="check()" label="审核通过" class="p-button-text">
        </p-button>
        <p-button icon="pi pi-check" *ngIf="editDialogType == 2" (click)="check_waybill_noPass(res)" label="审核不通过"
            class="p-button-text"></p-button>
        <button pButton pRipple icon="pi pi-times" type="button" label="取消" (click)="cancelSave()"
            class="p-button-raised p-button-text p-button-plain"></button>
    </ng-template>
</p-dialog>
<!-- 编辑司机结束 -->

<!-- 证件上传 -->
<p-overlayPanel #uploadMenu>
    <ng-template pTemplate>
        <ng-container *ngFor="let item of uploadItems">
            <div style="width:120px;height:36px;line-height: 36px;text-align: center;font-size: small;cursor:pointer;"
                class="edit-font" (click)="chooseUpload(item)">
                {{item.uploadFileTitle}}
            </div>
        </ng-container>
    </ng-template>
</p-overlayPanel>

<!-- 上传公共图片 -->
<p-dialog [(visible)]="uploadCommonDialog" [modal]="false" [style]="{width: '1000px'}" [baseZIndex]="10000"
    [draggable]="true" [keepInViewport]="false" [resizable]="false" *ngIf="uploadCommonDialog"
    (onShow)="dialogBlock = true">
    <!-- <ng-template pTemplate="header">
        <span style="font-weight: 600;font-size: large;margin-right:20px;">
            {{dialogTitle}}
            <span style="font-weight: 700;font-size: small;">( {{ dialogSubTitle }} )</span>
        </span>
    </ng-template> -->
    <ng-template pTemplate="header">
        <div class="p-dialog-title">
            {{dialogTitle}}
        </div>
        <button type="button" [ngClass]="{ 'p-dialog-header-icon p-dialog-header-close p-link': true }"
            (click)="dialogBlock = false || uploadCommonDialog = false" pRipple>
            <span class="p-dialog-header-close-icon" class="pi pi-times">( {{ dialogSubTitle }} )</span>
        </button>
    </ng-template>
    <p-fileUpload #fileUpload name="uploadFile" [url]="saveDriverUploadFile" [headers]="{'upload': true}"
        (onUpload)="onUpload($event)" [showCancelButton]="false" chooseLabel="选择" uploadLabel="上传" multiple="multiple"
        [maxFileSize]="1024 * 1024 * 5" (onBeforeUpload)="setUploadData($event)" previewWidth=120
        [files]="uploadedFiles">
        <ng-template pTemplate="content">
            <ul *ngIf="uploadedFiles.length">
                <li *ngFor="let file of uploadedFiles">{{file.name}} - {{file.size}} bytes</li>
            </ul>
        </ng-template>
    </p-fileUpload>
</p-dialog>

<!-- 司机审核弹窗 -->
<p-dialog [(visible)]="checkDriverDialog" [modal]="false" [style]="{width: dialog_width_small}"
    *ngIf="checkDriverDialog" [baseZIndex]="10000" [draggable]="true" [resizable]="false" [keepInViewport]="false"
    (onShow)="dialogBlock = true">
    <ng-template pTemplate="header">
        <div class="p-dialog-title">
            批量审核
        </div>
        <button type="button" [ngClass]="{ 'p-dialog-header-icon p-dialog-header-close p-link': true }"
            (click)="dialogBlock = false || checkDriverDialog = false" pRipple>
            <span class="p-dialog-header-close-icon" class="pi pi-times"></span>
        </button>
    </ng-template>
    <form [formGroup]="checkDriverForm">
        <div class="p-field p-grid">
            <label for="checkFlag" class="p-col-fixed" style="width:90px;">审核状态</label>
            <div class="p-col">
                <p-radioButton name="checkFlag" value="2" class="p-mr-2" inputId="checkPass" formControlName="checkFlag"
                    (onClick)="changeCheckStatus(2)">
                </p-radioButton>
                <label class="p-mr-3" for="checkPass">审核通过</label>
                <p-radioButton name="checkFlag" value="3" class="p-mr-2" inputId="checkReject"
                    formControlName="checkFlag" (onClick)="changeCheckStatus(3)">
                </p-radioButton>
                <label class="p-mr-3" for="checkReject">审核不通过</label>
            </div>
        </div>
        <div class="p-field p-grid" *ngIf="currentDriverCheckFlag == 3">
            <label for="checkLog" class="p-col-fixed" style="width:90px;">审核备注</label>
            <div class="p-col">
                <input id="checkLog" type="text" pInputText formControlName="checkLog" style="width:100%;">
            </div>
            <small *ngIf="checkFormItem(this.checkDriverForm, 'checkLog')" class="p-error block error-msg">
                请填写审核不通过原因
            </small>
        </div>
    </form>
    <ng-template pTemplate="footer">
        <p-button icon="pi pi-check" (click)="saveCheckDriver()" label="保存" class="p-button-text"></p-button>
        <button pButton pRipple icon="pi pi-times" type="button" label="取消"
            (click)="checkDriverDialog = false|| dialogBlock = false"
            class="p-button-raised p-button-text p-button-plain"></button>
    </ng-template>
</p-dialog>

<!-- 审核不通过开始 -->
<p-dialog class="edit-order" [(visible)]="noCheckWaybillDialogFlag" position="center" [dismissableMask]="false"
    [modal]="false" [style]="{width:'500px'}" [draggable]="true" [resizable]="false" [keepInViewport]="false"
    [baseZIndex]="100000" *ngIf="noCheckWaybillDialogFlag" (onShow)="dialogBlock = true">
    <ng-template pTemplate="header">
        <div class="p-dialog-title">
            审核不通过
        </div>
        <button type="button" [ngClass]="{ 'p-dialog-header-icon p-dialog-header-close p-link': true }"
            (click)="dialogBlock = false || noCheckWaybillDialogFlag = false" pRipple>
            <span class="p-dialog-header-close-icon" class="pi pi-times"></span>
        </button>
    </ng-template>
    <form [formGroup]="checkWaybillForm" style="background-color: #ffffff;border-radius: 12px;padding:24px 16px;">
        <div class="p-field p-col-6 p-md-12 edit-sel">
            <div class="filed-input">
                <p-radioButton required name="checkLogTips" (click)="checkLogTipsClick(1)" value="1"
                    formControlName="checkLogTips">
                </p-radioButton>
                &nbsp;
                <label class="deposit">身份证正面照片模糊</label>
                &nbsp;
                <p-radioButton required name="checkLogTips" (click)="checkLogTipsClick(2)" value="2"
                    formControlName="checkLogTips">
                </p-radioButton>
                &nbsp;
                <label class="fdeposit">身份证背面照片模糊</label>
            </div>
        </div>
        <div class="p-field p-col-6 p-md-12 edit-sel">
            <div class="filed-input">
                <p-radioButton required name="checkLogTips" (click)="checkLogTipsClick(3)" value="3"
                    formControlName="checkLogTips">
                </p-radioButton>
                &nbsp;
                <label class="fdeposit">驾驶证照片模糊</label>
                &nbsp;
                <p-radioButton required name="checkLogTips" (click)="checkLogTipsClick(5)" value="5"
                    formControlName="checkLogTips">
                </p-radioButton>
                &nbsp;
                <label class="fdeposit">证件不符</label>
            </div>
        </div>
        <div class="p-field p-col-6 p-md-12 edit-sel">
            <div class="filed-input">
                <p-radioButton required name="checkLogTips" (click)="checkLogTipsClick(4)" value="4"
                    formControlName="checkLogTips">
                </p-radioButton>
                &nbsp;
                <label class="fdeposit">其它</label>
            </div>
        </div>
        <div class="p-field p-col-6 p-md-12 edit-sel" *ngIf="checkLogSwitch==1">
            <label for="check_log">其它原因</label>
            <div class="filed-input">
                <textarea pInputTextarea formControlName="checkLog" rows="5" cols="30" autoResize="autoResize"
                    style="width:98%"></textarea>
                <small *ngIf="checkFormItem(this.checkWaybillForm, 'checkLog')" class="p-error block error-msg">
                    请填写审核不通过原因
                </small>
            </div>
        </div>
    </form>
    <ng-template pTemplate="footer">
        <p-button icon="pi pi-check" (click)="noCheck()" label="确定" class="p-button-text"></p-button>
        <button pButton pRipple icon="pi pi-times" type="button" label="取消"
            (click)="noCheckWaybillDialogFlag = flase|| dialogBlock = false"
            class="p-button-raised p-button-text p-button-plain"></button>
    </ng-template>
</p-dialog>
<!-- 审核不通过结束 -->


<!-- 司机详情 -->
<p-detail-sidebar *ngIf="showDriverFlag" [(visible)]="showDriverFlag" [showCloseIcon]="false" position="right"
    [style]="{width:'80%'}" transitionOptions="600ms ease-in-out">
    <app-driver-detail [driverDetail]="driverDetail" (onClose)="showDriverFlag = false"></app-driver-detail>
</p-detail-sidebar>
<!-- <p-dialog *ngIf="showDriverFlag" [(visible)]="showDriverFlag" position="center" [draggable]="true" [resizable]="false"
    [dismissableMask]="true" [modal]="true" header='司机详情' [style]="{width:'1035px'}">
</p-dialog> -->

<!-- ======================================我的银行卡开始===============================================-->
<p-dialog [(visible)]="myBank['myBnakListDialogFlag']" [modal]="false" [style]="{width: '1200px'}"
    [draggable]="true" [resizable]="false" *ngIf="myBank['myBnakListDialogFlag']" [keepInViewport]="false"
    (onShow)="dialogBlock = true">
    <!-- <ng-template pTemplate="header">
        <span style="font-weight: 600;font-size: large;margin-right:20px;">
            银行卡
            <span style="font-weight: 700;font-size: small;">( {{ dialogSubTitle }} )</span>
        </span>
    </ng-template> -->
    <ng-template pTemplate="header">
        <div class="p-dialog-title">
            银行卡
            <span style="font-weight: 700;font-size: small;">( {{ dialogSubTitle }} )</span>
        </div>
        <button type="button" [ngClass]="{ 'p-dialog-header-icon p-dialog-header-close p-link': true }"
            (click)="dialogBlock = false || myBank['myBnakListDialogFlag']= false" pRipple>
            <span class="p-dialog-header-close-icon" class="pi pi-times"></span>
        </button>
    </ng-template>
    <div class="button-panel">
        <button pButton pRipple type="button" label="新增" icon="pi pi-plus" class="p-button-sm p-mr-2"
            (click)="editMyBankCard()"></button>
        <button pButton pRipple type="button" label="删除"
            [disabled]="!myBank['selectedBankList'] || !myBank['selectedBankList'].length" icon="pi pi-trash"
            class="p-button-sm p-button-danger" (click)="delMyCardBank()"></button>
        <button pButton pRipple type="button" label="刷新" icon="pi pi-search" class="p-button-sm p-ml-2"
            (click)="queryMyBanckCard()"></button>
    </div>
    <!-- <p-table [value]="myBank['bankDataList']" [loading]="loading" styleClass="p-datatable-sm" [scrollable]="true" scrollHeight="flex"
        [(selection)]="myBank['selectedBankList']"> -->

    <p-table [value]="myBank['bankDataList']" styleClass="p-datatable-sm p-datatable-gridlines" [loading]="loading"
        [resizableColumns]="true" columnResizeMode="expand" [@filterAnimation]="loadingNum" scrollHeight="flex"
        [(selection)]="myBank['selectedBankList']" selectionMode="single" dataKey="id">
        <colgroup>
            <col style="text-align: center;width:170px;" />
            <col style="text-align: center;width:120px;" />
            <col style="text-align: center;width:120px;" />
            <col style="text-align: center;width:150px;" />
            <col style="text-align: center;width:120px;" />
        </colgroup>
        <ng-template pTemplate="header">
            <tr>
                <th style="text-align: center;width:36px" class="first frozenColumn pLeftFrozenColumn th">
                    <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
                </th>
                <th pResizableColumn class="th" style="text-align: center;width:170px">银行卡号</th>
                <th pResizableColumn class="th" style="text-align: center;width:120px">所属银行</th>
                <th pResizableColumn class="th" style="text-align: center;width:120px">开户行</th>
                <th pResizableColumn class="th" style="text-align: center;width:150px">录入时间</th>
                <th pResizableColumn class="th" style="text-align: center;width:120px">南京银行虚拟户</th>
                  <th pResizableColumn class="th" style="text-align: center;width:120px">操作</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage" *ngIf="myBank['selectedBankList'].length==0">
            <!-- <tr style="text-align: center;"  class="td">
                暂无数据
            </tr> -->
        </ng-template>
        <ng-template pTemplate="body" let-rowIndex="rowIndex" let-res>
            <tr [pSelectableRow]="res" [pSelectableRowIndex]="rowIndex">
                <td style="text-align: center;width:36px" class="td">
                    <p-tableCheckbox [value]="res"></p-tableCheckbox>
                </td>
                <td style="text-align: center;width:170px" class="td">{{res.accountNo}}</td>
                <td style="text-align: center;width:120px" class="td">{{res.cardType}}</td>
                <td style="text-align: center;width:120px" class="td">{{res.openAccountName}}</td>
                <td style="text-align: center;width:150px" class="td">{{this.setCreateTime(res.createTime * 1000)}}</td>
                <td style="text-align: center;width:120px" class="td">
                      <p-tag  [value]="njbkVirtualAccountStatusMap(res.njbkVirtualAccountStatus).text" [rounded]="true"
                        [style]="{'background-color':njbkVirtualAccountStatusMap(res.njbkVirtualAccountStatus).background}"></p-tag>
                </td>
                <td style="text-align: center;width:120px" class="td">
                    <a href="javascript:;" class="edit-font" *ngIf="res.njbkVirtualAccountStatus == 1" (click)="openAccount(res)">开户</a>
                </td>
            </tr>
        </ng-template>
    </p-table>
    <ng-template pTemplate="footer">
        <div style="height:20px;"></div>
    </ng-template>
</p-dialog>

<p-dialog [(visible)]="myBank['editMyBankDialogFlag']" [modal]="false" *ngIf="myBank['editMyBankDialogFlag']"
    [style]="{  width: dialog_width_small}" class="edit-data" [draggable]="true" [resizable]="false"
    [keepInViewport]="false"
    (onShow)="editUploadBankDFileUpload.clear() || (myBank['bankPhotoUrl'] = 'assets/file/image/pho_yinhangka@2x.png')">
    <ng-template pTemplate="header">
        <div class="p-dialog-title">
            上传银行卡
        </div>
        <button type="button" [ngClass]="{ 'p-dialog-header-icon p-dialog-header-close p-link': true }"
            (click)="dialogBlock = false || myBank['editMyBankDialogFlag']= false" pRipple>
            <span class="p-dialog-header-close-icon" class="pi pi-times"></span>
        </button>
    </ng-template>
    <form [formGroup]="validateBankForm" style="width:100%;padding:24px 16px 0 16px;">
        <div class="p-field upload-photo-box" [style]="{backgroundImage: 'url(' + myBank['bankPhotoUrl'] + ')'}">
            <span class="upload-photo upload-photo-span">
                <p-fileUpload #editUploadBankDFileUpload mode="basic" chooseLabel="" name="bankFile"
                    (onSelect)="onSelectBankCard($event)" [fileLimit]="1" accept="image/*"
                    [style]="{'zIndex':'10',opacity:'0',width: '100%', height: '200px'}" maxFileSize="32*1048*1048">
                </p-fileUpload>
                <a *ngIf="myBank['bankPhotoUrl'] != 'assets/file/image/pho_yinhangka@2x.png'" class="upload-photo-a"
                    href="javascript:;" pRipple
                    (click)="editUploadBankDFileUpload.clear() || (myBank['bankPhotoUrl'] = 'assets/file/image/pho_yinhangka@2x.png')">
                    <i class="pi pi-trash"></i>
                </a>
            </span>
        </div>

        <div class="p-field p-grid">
            <label for="bankName" class="p-col-fixed" style="width:110px;">银行名称</label>
            <div class="p-col">
                <input id="bankName" type="text" disabled pInputText formControlName="bankName" style="width:100%;"
                    placeholder="请输入银行名称">
            </div>
        </div>
        <div class="p-field p-grid">
            <label for="accountNo" class="p-col-fixed" style="width:110px;">银行卡号</label>
            <div class="p-col">
                <!-- <input id="accountNo" type="text" pInputText formControlName="accountNo" style="width:100%;"> -->
                <p-inputMask id="accountNo" formControlName="accountNo" [style]="{width: '100%'}"
                    class="p-inputtext-sm p-text-value cus_input" mask="9999 9999 9999 9999 999" [autoClear]="false">
                </p-inputMask>
            </div>
        </div>
        <div class="p-field p-grid">
            <label for="bankReservePhone" class="p-col-fixed" style="width:110px;">银行预留手机</label>
            <div class="p-col">
                <div class="p-inputgroup">
                    <input id="bankReservePhone" type="text" pInputText formControlName="bankReservePhone"
                        style="width:100%;" placeholder="请输入银行预留手机">
                    <button pButton type="button" class="p-button-sm" style="white-space: nowrap; min-width: 80px;"
                        label="{{ smsCountDown > 0 ? smsCountDown + 's后重试' : '获取验证码' }}" [disabled]="smsCountDown > 0"
                        (click)="getBankPhoneVerifyCode()"></button>
                </div>
            </div>
        </div>
        <div class="p-field p-grid">
            <label for="validateNum" class="p-col-fixed" style="width:110px;">验证码</label>
            <div class="p-col">
                <input id="validateNum" type="text" pInputText formControlName="validateNum" style="width:100%;"
                    placeholder="请输入验证码">
            </div>
        </div>
    </form>
    <ng-template pTemplate="footer">
        <input #editUploadInput type="hidden" (click)="editUploadBankDFileUpload.clear()" />
        <!-- <ng-container *ngIf="bankForceBindStatus == 1">
            <p-button icon="pi pi-check" (click)="saveMyCardBank('1')" label="强制绑卡" class="p-button-text"></p-button>
        </ng-container> -->
        <p-button icon="pi pi-check" (click)="checkBankCardLegel()" label="保存" class="p-button-text"></p-button>
        <button pButton pRipple icon="pi pi-times" type="button" label="取消"
            (click)="myBank['editMyBankDialogFlag'] = false|| dialogBlock = false"
            class="p-button-raised p-button-text p-button-plain"></button>
    </ng-template>
</p-dialog>
<!-- ======================================我的银行卡结束===============================================-->

<!-- =======================================我的车辆开始================================================-->
<p-dialog [(visible)]="myTruck['myTruckListDialogFlag']" [modal]="false" [style]="{width: dialog_width_large}"
    [draggable]="true" [resizable]="false" [keepInViewport]="false" *ngIf="myTruck['myTruckListDialogFlag']"
    (onShow)="dialogBlock = true">
    <!-- <ng-template pTemplate="header">
        <span style="font-weight: 600;font-size: large;margin-right:20px;">
            车辆列表
            <span style="font-weight: 700;font-size: small;">( {{ dialogSubTitle }} )</span>
        </span>
    </ng-template> -->
    <ng-template pTemplate="header">
        <div class="p-dialog-title">
            车辆列表
            <span style="font-weight: 700;font-size: small;">( {{ dialogSubTitle }} )</span>
        </div>
        <button type="button" [ngClass]="{ 'p-dialog-header-icon p-dialog-header-close p-link': true }"
            (click)="dialogBlock = false || myTruck['myTruckListDialogFlag']= false" pRipple>
            <span class="p-dialog-header-close-icon" class="pi pi-times"></span>
        </button>
    </ng-template>
    <div style="padding: 5px 0;">
        <div class="p-d-flex p-ai-center p-jc-between">
            <div class="search-panel">
                <form id="formGroup" [formGroup]="truckValidateForm">
                    <div class="form-item" name="plateNumber">
                        <label for="plateNumber" class="p-mr-2 p-d-inline">车牌号</label>
                        <input type="text" id="plateNumber" pInputText class="p-mr-2 p-d-inline" class="p-inputtext-sm"
                            formControlName="plateNumber" />
                    </div>
                    <div class="form-item">
                        <button pButton pRipple type="button" label="查询" icon="pi pi-search" class="p-button-sm p-ml-2"
                            (click)="driverTruckList()"></button>
                    </div>
                </form>
            </div>
            <div>
                <button pButton pRipple type="button" label="新增" icon="pi pi-plus" class="p-button-sm p-mr-2"
                    (click)="editMyTruck()"></button>
                <!-- <button pButton pRipple type="button" label="审核" [disabled]="myTruck['selectedTruckList'].length === 0"
            icon="pi pi-plus" class="p-button-sm p-mr-2" (click)="checkRelDriverTruck()"></button> -->
                <button pButton pRipple type="button" label="删除" [disabled]="myTruck['selectedTruckList'].length === 0"
                    icon="pi pi-trash" class="p-button-sm p-button-danger" (click)="delMyTruck()"></button>
                <button pButton pRipple type="button" label="刷新" icon="pi pi-search" class="p-button-sm p-ml-2"
                    (click)="commonGetDriverList()"></button>
            </div>
        </div>
    </div>
    <!-- <div class="button-panel">
        
        
    </div> -->

    <!-- <p-table [value]="myTruck['trucksDataList']" styleClass="p-datatable-sm" [scrollable]="true" scrollHeight="flex"
        [(selection)]="myTruck['selectedTruckList']"> -->

    <p-table [value]="myTruck['trucksDataList']" styleClass="p-datatable-sm p-datatable-gridlines"
        [resizableColumns]="true" columnResizeMode="expand" [@filterAnimation]="loadingNum" scrollHeight="flex"
        [(selection)]="myTruck['selectedTruckList']" selectionMode="single" dataKey="id">
        <ng-template pTemplate="header">
            <tr>
                <th style="width:50px;text-align: center;" class="first frozenColumn pLeftFrozenColumn th">
                    序号
                </th>
                <th style="width:36px" class="first frozenColumn pLeftFrozenColumn th">
                    <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
                </th>
                <th pResizableColumn class="first frozenColumn pLeftFrozenColumn th"
                    style="text-align: center;width:120px;">车牌号</th>
                <th pResizableColumn class="first frozenColumn pLeftFrozenColumn th"
                    style="text-align: center;width:120px;">是否默认</th>
                <th pResizableColumn class="first frozenColumn pLeftFrozenColumn th"
                    style="text-align: center;width:120px;">人车照审核状态</th>
                <th pResizableColumn class="first frozenColumn pLeftFrozenColumn th"
                    style="text-align: center;width:120px;">审核人</th>
                <th pResizableColumn class="first frozenColumn pLeftFrozenColumn th"
                    style="text-align: center;width:120px;">审核日志</th>
                <th pResizableColumn class="first frozenColumn pLeftFrozenColumn th"
                    style="text-align: center;width:120px;">人车照片</th>
                <th pResizableColumn class="first frozenColumn pLeftFrozenColumn th"
                    style="text-align: center;width:120px;">操作</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-rowIndex="rowIndex" let-res>
            <tr [pSelectableRow]="res" [pSelectableRowIndex]="rowIndex">
                <td style="width:50px;text-align: center;" class="first frozenColumn pLeftFrozenColumn td">
                    {{first+rowIndex+1}}
                </td>
                <td style="width:36px" class="first frozenColumn pLeftFrozenColumn td">
                    <p-tableCheckbox [value]="res"></p-tableCheckbox>
                </td>
                <td class="first frozenColumn pLeftFrozenColumn td" style="text-align: center;width:120px;">
                    <a href="javascript:;" pRipple class="show-detail edit-font"
                        (click)="showTruckDetail(res)">{{res.plateNumber}}</a>
                </td>
                <td style="text-align: center;width:120px;" class="td">
                    {{res['isDefault'] ==1 ? '默认' : '非默认'}}
                </td>
                <td class="first frozenColumn pLeftFrozenColumn td" style="text-align: center;width:120px;">
                    <p-tag *ngIf="res.checkFlag==1" [value]="checkFlag[res.checkFlag]" [rounded]="true"
                        [style]="{'background-color': '#B15BFF'}"></p-tag>
                    <p-tag *ngIf="res.checkFlag==2" [value]="checkFlag[res.checkFlag]" [rounded]="true"
                        [style]="{'background-color': '#00A600'}"></p-tag>
                    <p-tag *ngIf="res.checkFlag==3" [value]="checkFlag[res.checkFlag]" [rounded]="true"
                        [style]="{'background-color': '#EA0000'}"></p-tag>
                </td>
                <td class="first frozenColumn pLeftFrozenColumn td" style="text-align: center;width:120px;">
                    {{res['checkName']}} </td>
                <td class="first frozenColumn pLeftFrozenColumn td" style="text-align: center;width:120px;">
                    {{res['checkLog']}}
                </td>
                <td class="first frozenColumn pLeftFrozenColumn td" style="text-align: center;width:120px;">
                    <ng-container *ngIf="!res.driverTruckPhoto">
                        <a href="javascript:;" pRipple class="edit-font" (click)="uploadTruckPhoto(res)">上传</a>
                    </ng-container>
                    <ng-container *ngIf="res.driverTruckPhoto">
                        <a href="javascript:;" pRipple class="edit-font" (click)="uploadTruckPhoto(res)">上传</a>
                        <span style="margin: 0 4px;">|</span>
                        <a href="javascript:;" pRipple class="edit-font" (click)="checkDriverTruckPhoto(res)">查看</a>
                    </ng-container>
                </td>
                <td class="first frozenColumn pLeftFrozenColumn td" style="text-align: center;width:120px;">
                    <ng-container *ngIf="res.isDefault ==0">
                        <a href="javascript:;" pRipple class="edit-font" (click)="defaultTruck(res)">设置默认</a>
                    </ng-container>
                </td>
            </tr>
        </ng-template>
    </p-table>
    <ng-template pTemplate="footer">
        <div style="height:20px;"></div>
    </ng-template>
</p-dialog>

<!-- 关联车辆信息 -->
<p-dialog [(visible)]="myTruck['truckCheckDialogFlag']" [modal]="false" [style]="{width: dialog_width_small}"
    [draggable]="true" [resizable]="false" [keepInViewport]="false" *ngIf="myTruck['truckCheckDialogFlag']"
    (onShow)="dialogBlock = true">
    <ng-template pTemplate="header">
        <div class="p-dialog-title">
            请输入车牌号
        </div>
        <button type="button" [ngClass]="{ 'p-dialog-header-icon p-dialog-header-close p-link': true }"
            (click)="dialogBlock = false || myTruck['truckCheckDialogFlag']= false" pRipple>
            <span class="p-dialog-header-close-icon" class="pi pi-times"></span>
        </button>
    </ng-template>
    <div style="width:100%;padding:24px 16px 0 16px;">
        <div class="p-field p-grid">
            <label for="account_no" class="p-col-fixed" style="width:90px;">
                车牌号
            </label>
            <div class="p-col">
                <span class="p-input-icon-right">
                    <i style="color: red;font-size: 14px;" *ngIf="myTruck['plateNumber'].length == 8"> 新能源 </i>
                    <input id="account_no" type="text" pInputText [(ngModel)]="myTruck['plateNumber']"
                        class="p-inputtext-sm" style="width:100%;" autocomplete="off">
                </span>
            </div>
        </div>
    </div>
    <ng-template pTemplate="footer">
        <p-button icon="pi pi-check" (click)="queryTruck()" label="下一步" class="p-button-text"></p-button>
        <button pButton pRipple icon="pi pi-times" type="button" label="取消"
            (click)="myTruck['truckCheckDialogFlag'] = false|| dialogBlock = false"
            class="p-button-raised p-button-text p-button-plain"></button>
    </ng-template>
</p-dialog>

<!-- 新增车辆基本信息-->
<p-dialog [(visible)]="myTruck['truckEditDialogFlag']" [modal]="false" class="edit-data"
    [style]="{width: dialog_width_middler }" [draggable]="true" [resizable]="false" [keepInViewport]="false"
    *ngIf="myTruck['truckEditDialogFlag']" (onShow)="dialogBlock = true">
    <ng-template pTemplate="header">
        <div class="p-dialog-title">
            关联车辆
        </div>
        <button type="button" [ngClass]="{ 'p-dialog-header-icon p-dialog-header-close p-link': true }"
            (click)="dialogBlock = false || myTruck['truckEditDialogFlag']= false" pRipple>
            <span class="p-dialog-header-close-icon" class="pi pi-times"></span>
        </button>
    </ng-template>
    <form [formGroup]="validateTruckForm" style="width:100%;padding:0 16px 0 16px;">
        <div class="p-fluid p-formgrid p-grid" style="overflow-x:hidden;">
            <div class="p-field p-grid">
                <div class="p-md-6 filed-item">
                    <div class="p-display upload-file-box">
                        <div class="p-display">
                            <div class="p-mr-3">
                                <img [src]="vehicleLicensePhotoUrl" image-viewer
                                    (click)="priviewImgs(vehicleLicensePhotoUrl)" class="upload-file-back" />
                            </div>
                            <div>
                                <div style="font-size:large;font-weight:700;">
                                    行驶证主页<span class="label-sel">*</span>
                                </div>
                                <div>
                                    请上传车辆行驶证扫描件或数码照，支持jpg,jpeg,png格式照片
                                </div>
                            </div>
                        </div>
                        <div>
                            <div class="upload-photo-box" [style]="{width: '100px', height: '30px'}">
                                <span class="upload-photo upload-photo-span"
                                    style="width: '100px'; height: '30px';z-index: 5;">
                                    <p-fileUpload #vehicleLicensePhotoFileUpload mode="basic" chooseLabel=""
                                        (onSelect)="onSelectLicense($event)" [fileLimit]="1" accept="image/*"
                                        multiple="multiple"
                                        [style]="{'zIndex': '10',opacity:'0',width: '380px', height: '75px',right: '280px',bottom: '23px'}"
                                        maxFileSize="32*1048*1048"></p-fileUpload>
                                </span>
                                <span class="upload-photo upload-photo-span"
                                    style="width: '100px'; height: '30px';z-index: 2;">
                                    <button pButton pRipple type="button"
                                        [label]="vehicleLicensePhotoUrl=='assets/file/image/xsz.png' ? '点击上传':'重新上传'"
                                        class="p-button-sm" icon="pi pi-cloud-upload"
                                        [style]="{'width':'100px'}"></button>
                                    <input #vehicleLicensePhotoInput type="hidden"
                                        (click)="vehicleLicensePhotoFileUpload.clear()" />
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="p-md-6 filed-item">
                    <div class="p-display upload-file-box">
                        <div class="p-display">
                            <div class="p-mr-3">
                                <img [src]="vehicleLicenseBackPhotoUrl" image-viewer
                                    (click)="priviewImgs(vehicleLicenseBackPhotoUrl)" class="upload-file-back" />
                            </div>
                            <div>
                                <div style="font-size:large;font-weight:700;">
                                    行驶证副页<span class="label-sel">*</span>
                                </div>
                                <div>
                                    请上传车辆行驶证扫描件或数码照，支持jpg,jpeg,png格式照片
                                </div>
                            </div>
                        </div>
                        <div>
                            <div class="upload-photo-box" [style]="{width: '100px', height: '30px'}">
                                <span class="upload-photo upload-photo-span"
                                    style="width: '100px'; height: '30px';z-index: 5;">
                                    <p-fileUpload #vehicleLicenseBackPhotoFileUpload mode="basic" chooseLabel=""
                                        (onSelect)="onSelectLicenseBack($event)" [fileLimit]="1" accept="image/*"
                                        multiple="multiple"
                                        [style]="{'zIndex': '10',opacity:'0',width: '380px', height: '75px',right: '280px',bottom: '23px'}"
                                        maxFileSize="32*1048*1048"></p-fileUpload>
                                </span>
                                <span class="upload-photo upload-photo-span"
                                    style="width: '100px'; height: '30px';z-index: 2;">
                                    <button pButton pRipple type="button"
                                        [label]="vehicleLicenseBackPhotoUrl=='assets/file/image/xsz.png' ? '点击上传':'重新上传'"
                                        class="p-button-sm" icon="pi pi-cloud-upload"
                                        [style]="{'width':'100px'}"></button>
                                    <input #vehicleLicenseBackPhotoInput type="hidden"
                                        (click)="vehicleLicenseBackPhotoFileUpload.clear()" />
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="p-md-6 filed-item">
                    <div class="p-display upload-file-box">
                        <div class="p-display">
                            <div class="p-mr-3">
                                <img [src]="optCertPhotoUrl" image-viewer (click)="priviewImgs(optCertPhotoUrl)"
                                    class="upload-file-back" />
                            </div>
                            <div>
                                <div style="font-size:large;font-weight:700;">
                                    道路运输证照片<span class="label-sel">*</span>
                                </div>
                                <div>
                                    请上传道路运输证扫描件或数码照，支持jpg,jpeg,png格式照片
                                </div>
                            </div>
                        </div>
                        <div>
                            <div class="upload-photo-box" [style]="{width: '100px', height: '30px'}">
                                <span class="upload-photo upload-photo-span"
                                    style="width: '100px'; height: '30px';z-index: 5;">
                                    <p-fileUpload #optCertPhotoFileUpload mode="basic" chooseLabel=""
                                        (onSelect)="onSelectOptCert($event)" [fileLimit]="1" accept="image/*"
                                        multiple="multiple"
                                        [style]="{'zIndex': '10',opacity:'0',width: '380px', height: '75px',right: '280px',bottom: '23px'}"
                                        maxFileSize="32*1048*1048"></p-fileUpload>
                                </span>
                                <span class="upload-photo upload-photo-span"
                                    style="width: '100px'; height: '30px';z-index: 2;">
                                    <button pButton pRipple type="button"
                                        [label]="optCertPhotoUrl=='assets/file/image/dlysz.png' ? '点击上传':'重新上传'"
                                        class="p-button-sm" icon="pi pi-cloud-upload"
                                        [style]="{'width':'100px'}"></button>
                                    <input #optCertPhotoFileInput type="hidden"
                                        (click)="optCertPhotoFileUpload.clear()" />
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="p-md-6 filed-item">
                    <div class="p-display upload-file-box">
                        <div class="p-display">
                            <div class="p-mr-3">
                                <img [src]="vehicleLicenseCheckPhotoUrl" image-viewer
                                    (click)="priviewImgs(vehicleLicenseCheckPhotoUrl)" class="upload-file-back" />
                            </div>
                            <div>
                                <div style="font-size:large;font-weight:700;">
                                    车辆年审页照片<span class="label-sel">*</span>
                                </div>
                                <div>
                                    请上传车辆年审页照片，支持jpg,jpeg,png格式照片
                                </div>
                            </div>
                        </div>
                        <div>
                            <div class="upload-photo-box" [style]="{width: '100px', height: '30px'}">
                                <span class="upload-photo upload-photo-span"
                                    style="width: '100px'; height: '30px';z-index: 5;">
                                    <p-fileUpload #vehicleLicenseCheckFileUpload mode="basic" chooseLabel=""
                                        (onSelect)="onSelectVehicleLicenseCheck($event)" [fileLimit]="1"
                                        accept="image/*" multiple="multiple"
                                        [style]="{'zIndex': '10',opacity:'0',width: '480px', height: '75px',right: '380px',bottom: '23px'}"
                                        maxFileSize="32*1048*1048"></p-fileUpload>
                                </span>
                                <span class="upload-photo upload-photo-span"
                                    style="width: '100px'; height: '30px';z-index: 2;">
                                    <button pButton pRipple type="button"
                                        [label]="vehicleLicenseCheckPhotoUrl=='assets/file/image/xszfy.png' ? '点击上传':'重新上传'"
                                        class="p-button-sm" icon="pi pi-cloud-upload"
                                        [style]="{'width':'100px'}"></button>
                                    <input #vehicleLicenseCheckFileInput type="hidden"
                                        (click)="vehicleLicenseCheckFileUpload.clear()" />
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="p-md-6 filed-item">
                    <div class="p-display upload-file-box">
                        <div class="p-display">
                            <div class="p-mr-3">
                                <img [src]="driverTruckPhotoUrl" image-viewer (click)="priviewImgs(driverTruckPhotoUrl)"
                                    class="upload-file-back" />
                            </div>
                            <div>
                                <div style="font-size:large;font-weight:700;">
                                    人车照<span class="label-sel">*</span>
                                </div>
                                <div>
                                    请上传人车照片扫描件或数码照，支持jpg,jpeg,png格式照片
                                </div>
                            </div>
                        </div>
                        <div>
                            <div class="upload-photo-box" [style]="{width: '100px', height: '30px'}">
                                <span class="upload-photo upload-photo-span"
                                    style="width: '100px'; height: '30px';z-index: 5;">
                                    <p-fileUpload #driverTruckFileUpload mode="basic" chooseLabel=""
                                        (onSelect)="onSelectDriverTruck($event)" [fileLimit]="1" accept="image/*"
                                        multiple="multiple"
                                        [style]="{'zIndex': '10',opacity:'0',width: '380px', height: '75px',right: '280px',bottom: '23px'}"
                                        maxFileSize="32*1048*1048"></p-fileUpload>
                                </span>
                                <span class="upload-photo upload-photo-span"
                                    style="width: '100px'; height: '30px';z-index: 2;">
                                    <button pButton pRipple type="button"
                                        [label]="driverTruckPhotoUrl=='assets/file/image/dlysz.png' ? '点击上传':'重新上传'"
                                        class="p-button-sm" icon="pi pi-cloud-upload"
                                        [style]="{'width':'100px'}"></button>
                                    <input #driverTruckInput type="hidden" (click)="driverTruckFileUpload.clear()" />
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="p-md-6 filed-item">
                    <div class="p-display upload-file-box">
                        <div class="p-display">
                            <div class="p-mr-3">
                                <img [src]="mountingAgreementPhotoUrl" image-viewer (click)="priviewImgs(mountingAgreementPhotoUrl)"
                                    class="upload-file-back" />
                            </div>
                            <div>
                                <div style="font-size:large;font-weight:700;">
                                    挂靠协议照片
                                </div>
                                <div>
                                    请上传挂靠协议照片，支持jpg,jpeg,png格式照片
                                </div>
                            </div>
                        </div>
                        <div>
                            <div class="upload-photo-box" [style]="{width: '100px', height: '30px'}">
                                <span class="upload-photo upload-photo-span"
                                    style="width: '100px'; height: '30px';z-index: 5;">
                                    <p-fileUpload #mountingAgreementFileUpload mode="basic" chooseLabel=""
                                        (onSelect)="onSelectMountingAgreement($event)" [fileLimit]="1" accept="image/*"
                                        multiple="multiple"
                                        [style]="{'zIndex': '10',opacity:'0',width: '380px', height: '75px',right: '280px',bottom: '23px'}"
                                        maxFileSize="32*1048*1048"></p-fileUpload>
                                </span>
                                <span class="upload-photo upload-photo-span"
                                    style="width: '100px'; height: '30px';z-index: 2;">
                                    <button pButton pRipple type="button"
                                        [label]="mountingAgreementPhotoUrl=='assets/file/image/dlysz.png' ? '点击上传':'重新上传'"
                                        class="p-button-sm" icon="pi pi-cloud-upload"
                                        [style]="{'width':'100px'}"></button>
                                    <input #mountingAgreementFileInput type="hidden" (click)="mountingAgreementFileUpload.clear()" />
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="p-field p-col-6 p-md-12"
                    style="font-weight: 700;font-size:18px;color: var(--text-color);padding-top: 15px;">车辆基本信息</div>
                <div class="p-field p-col-6 p-md-3 edit-sel">
                    <label for="plateNumber">车牌号
                        <span class="label-sel">*</span>
                    </label>
                    <input id="plateNumber" type="text" pInputText formControlName="plateNumber" class="p-inputtext-sm">
                    <small *ngIf="checkFormItem(this.validateTruckForm, 'plateNumber')" class="p-error block error-msg">
                        请填写车牌号
                    </small>
                </div>
                <div class="p-field p-col-6 p-md-3 edit-sel">
                    <label for="vehicleType">车辆类型
                        <span class="label-sel">*</span>
                    </label>
                    <p-dp-detail [options]="vehicleTypeList" formControlName="vehicleType" filter="true"
                        id="vehicleType" appendTo="body" class="p-inputtext-sm">
                    </p-dp-detail>
                    <small *ngIf="checkFormItem(this.validateTruckForm, 'vehicleType')" class="p-error block error-msg">
                        请选择车辆类型
                    </small>
                </div>
                <div class="p-field p-col-6 p-md-3 edit-sel">
                    <label for="length">车辆长度(mm)
                        <span class="label-sel">*</span>
                    </label>
                    <input id="length" type="number" pInputText formControlName="length" class="p-inputtext-sm">
                    <small *ngIf="checkFormItem(this.validateTruckForm, 'length')" class="p-error block error-msg">
                        请填写车辆长度
                    </small>
                </div>
                <div class="p-field p-col-6 p-md-3 edit-sel">
                    <label for="width">车辆宽度(mm)
                        <span class="label-sel">*</span>
                    </label>
                    <input id="width" type="number" pInputText formControlName="width" class="p-inputtext-sm">
                    <small *ngIf="checkFormItem(this.validateTruckForm, 'width')" class="p-error block error-msg">
                        请填写车辆宽度
                    </small>
                </div>
                <div class="p-field p-col-6 p-md-3 edit-sel">
                    <label for="height">车辆高度(mm)
                        <span class="label-sel">*</span>
                    </label>
                    <input id="height" type="number" pInputText formControlName="height" class="p-inputtext-sm">
                    <small *ngIf="checkFormItem(this.validateTruckForm, 'height')" class="p-error block error-msg">
                        请填写车辆高度
                    </small>
                </div>
                <div class="p-field p-col-6 p-md-3 edit-sel">
                    <label for="loadWeight">车辆核载(KG)
                        <span class="label-sel">*</span>
                    </label>
                    <input id="loadWeight" type="number" pInputText formControlName="loadWeight" class="p-inputtext-sm">
                    <small *ngIf="checkFormItem(this.validateTruckForm, 'loadWeight')" class="p-error block error-msg">
                        请填写车辆核载
                    </small>
                </div>
                <div class="p-field p-col-6 p-md-3 edit-sel">
                    <label for="fullLoadWeight">车辆满载(KG)
                        <span class="label-sel">*</span>
                    </label>
                    <input id="fullLoadWeight" type="number" pInputText formControlName="fullLoadWeight"
                        class="p-inputtext-sm">
                    <small *ngIf="checkFormItem(this.validateTruckForm, 'fullLoadWeight')"
                        class="p-error block error-msg">
                        请填写车辆满载
                    </small>
                </div>
                <div class="p-field p-col-6 p-md-3 edit-sel">
                    <label for="trailerVolume">车辆体积(方)</label>
                    <input id="trailerVolume" type="number" pInputText formControlName="trailerVolume"
                        class="p-inputtext-sm">
                </div>
                <div class="p-field p-col-6 p-md-3 edit-sel">
                    <label for="model">车辆品牌</label>
                    <input id="model" type="text" pInputText formControlName="model" class="p-inputtext-sm">
                </div>
                <div class="p-field p-col-6 p-md-3 edit-sel">
                    <label for="plateColor">车牌颜色
                        <span class="label-sel">*</span>
                    </label>
                    <p-dp-detail [options]="plateColorLists" formControlName="plateColor" filter="true" id="plateColor"
                        appendTo="body" class="p-inputtext-sm">
                    </p-dp-detail>
                    <small *ngIf="checkFormItem(this.validateTruckForm, 'loadWeight')" class="p-error block error-msg">
                        请选择车牌颜色
                    </small>
                </div>
                <div class="p-field p-col-6 p-md-3 edit-sel">
                    <label for="energyType">车辆能源类型
                        <span class="label-sel">*</span>
                    </label>
                    <p-dp-detail [options]="energyTypeLists" formControlName="energyType" filter="true" id="energyType"
                        appendTo="body" class="p-inputtext-sm">
                    </p-dp-detail>
                    <small *ngIf="checkFormItem(this.validateTruckForm, 'loadWeight')" class="p-error block error-msg">
                        请选择车辆能源类型
                    </small>
                </div>
                <div class="p-field p-col-6 p-md-3 edit-sel">
                    <label for="trailerPlateNumber">挂车车牌号码
                        <span class="label-sel" *ngIf="isTractorVehicleType()">*</span>
                    </label>
                    <input id="trailerPlateNumber" type="text" pInputText formControlName="trailerPlateNumber"
                        class="p-inputtext-sm">
                    <small *ngIf="checkFormItem(this.validateTruckForm, 'trailerPlateNumber') && isTractorVehicleType()" class="p-error block error-msg">
                        请填写挂车车牌号码
                    </small>
                </div>
                <div class="p-field p-col-6 p-md-3 edit-sel">
                    <label for="trailerPlateColor">挂车车牌颜色
                        <span class="label-sel" *ngIf="isTractorVehicleType()">*</span>
                    </label>
                    <p-dp-detail [options]="plateColorLists" formControlName="trailerPlateColor" filter="true" id="trailerPlateColor"
                        appendTo="body" class="p-inputtext-sm">
                    </p-dp-detail>
                    <small *ngIf="checkFormItem(this.validateTruckForm, 'trailerPlateColor') && isTractorVehicleType()" class="p-error block error-msg">
                        请选择挂车车牌颜色
                    </small>
                </div>
                <!-- 隐藏车长字段 -->
                <!-- <div class="p-field p-col-6 p-md-3 edit-sel">
                    <label for="truckSize">车长</label>
                    <p-dp-detail [options]="truckSizeLists" formControlName="truckSize" filter="true" id="truckSize"
                        appendTo="body" class="p-inputtext-sm">
                    </p-dp-detail>
                </div> -->
                <div class="p-field p-col-6 p-md-3 edit-sel">
                    <label for="isPersonal">车辆属性
                        <span class="label-sel">*</span>
                    </label>
                    <p-dp-detail [options]="isPersonalLists" formControlName="isPersonal" filter="true" id="isPersonal"
                        appendTo="body" class="p-inputtext-sm">
                    </p-dp-detail>
                    <small *ngIf="checkFormItem(this.validateTruckForm, 'isPersonal')" class="p-error block error-msg">
                        请选择车辆属性
                    </small>
                </div>
                <div class="p-field p-col-6 p-md-3 edit-sel">
                    <label for="useCharacter">使用性质
                        <span class="label-sel">*</span>
                    </label>
                    <p-dp-detail [options]="useCharacterLists" formControlName="useCharacter" filter="true"
                        id="useCharacter" appendTo="body" class="p-inputtext-sm">
                    </p-dp-detail>
                    <small *ngIf="checkFormItem(this.validateTruckForm, 'useCharacter')" class="p-error block error-msg">
                        请选择使用性质
                    </small>
                </div>
                <div class="p-field p-col-6 p-md-3 edit-sel">
                    <label for="truckVin">车辆识别代码
                        <span class="label-sel">*</span>
                    </label>
                    <input id="truckVin" type="text" pInputText formControlName="truckVin" class="p-inputtext-sm">
                    <small *ngIf="checkFormItem(this.validateTruckForm, 'truckVin')" class="p-error block error-msg">
                        请填写车辆识别代码
                    </small>
                </div>
                <!-- 隐藏车型字段 -->
                <!-- <div class="p-field p-col-6 p-md-3 edit-sel">
                    <label for="truckType">车型
                        <span class="label-sel">*</span>
                    </label>
                    <p-dp-detail [options]="truckModelLists" formControlName="truckType" filter="true" id="truckType"
                        appendTo="body" class="p-inputtext-sm">
                    </p-dp-detail>
                    <small *ngIf="checkFormItem(this.validateTruckForm, 'truckType')" class="p-error block error-msg">
                        请选择车型
                    </small>
                </div> -->
                <div class="p-field p-col-6 p-md-3 edit-sel">
                    <label for="axleCount">轴数
                        <span class="label-sel">*</span>
                    </label>
                    <input id="axleCount" type="number" pInputText formControlName="axleCount" class="p-inputtext-sm">
                    <small *ngIf="checkFormItem(this.validateTruckForm, 'axleCount')" class="p-error block error-msg">
                        请填写轴数
                    </small>
                </div>
                <div class="p-field p-col-6 p-md-3 edit-sel">
                    <label for="isPersonal">车主</label>
                    <p-dp-detail [options]="teamIdList" formControlName="teamId" filter="true" id="teamId"
                        appendTo="body" class="p-inputtext-sm">
                    </p-dp-detail>
                </div>

                <div class="p-field p-col-3 p-md-12" style="font-weight: 700;font-size:18px;color: var(--text-color);">
                    证件信息
                </div>

                <div class="p-field p-col-6 p-md-3 edit-sel">
                    <label for="ownName">业户名称
                        <span class="label-sel">*</span>
                    </label>
                    <input id="ownName" type="text" pInputText formControlName="ownName" class="p-inputtext-sm">
                    <small *ngIf="checkFormItem(this.validateTruckForm, 'ownName')" class="p-error block error-msg">
                        请填写业户名称
                    </small>
                </div>
                <div class="p-field p-col-6 p-md-3 edit-sel">
                    <label for="ownCarrierId">业户社会信用代码</label>
                    <input id="ownCarrierId" type="text" pInputText formControlName="ownCarrierId"
                        class="p-inputtext-sm">
                </div>
                <div class="p-field p-col-6 p-md-3 edit-sel">
                    <label for="businessCertificate">经营许可证号</label>
                    <input id="businessCertificate" type="text" pInputText formControlName="businessCertificate"
                        class="p-inputtext-sm">
                </div>
                <div class="p-field p-col-6 p-md-3  edit-sel">
                    <label for="businessCertificateExpireTime">经营许可证失效日期</label>
                    <p-calendar inputId="businessCertificateExpireTime" formControlName="businessCertificateExpireTime"
                        appendTo="body" dateFormat="yy-mm-dd" dataType="string" class="p-inputtext-sm"></p-calendar>
                </div>
                <div class="p-field p-col-6 p-md-3 edit-sel">
                    <label for="optCertNo">道路运输证号
                        <span class="label-sel">*</span>
                    </label>
                    <input id="optCertNo" type="text" pInputText formControlName="optCertNo" class="p-inputtext-sm">
                    <small *ngIf="checkFormItem(this.validateTruckForm, 'optCertNo')" class="p-error block error-msg">
                        请填写道路运输证号
                    </small>
                </div>
                <div class="p-field p-col-6 p-md-3  edit-sel">
                    <label for="optCertExpireTime">道路运输证失效日期
                        <span class="label-sel">*</span>
                    </label>
                    <p-calendar inputId="optCertExpireTime" formControlName="optCertExpireTime" appendTo="body"
                        dateFormat="yy-mm-dd" dataType="string" class="p-inputtext-sm"></p-calendar>
                    <small *ngIf="checkFormItem(this.validateTruckForm, 'optCertExpireTime')" class="p-error block error-msg">
                        请选择道路运输证失效日期
                    </small>
                </div>
                <div class="p-field p-col-6 p-md-3 edit-sel">
                    <label for="issuingOrganizations">行驶证发证机关
                        <span class="label-sel">*</span>
                    </label>
                    <input id="issuingOrganizations" type="text" pInputText formControlName="issuingOrganizations"
                        class="p-inputtext-sm">
                    <small *ngIf="checkFormItem(this.validateTruckForm, 'issuingOrganizations')" class="p-error block error-msg">
                        请填写行驶证发证机关
                    </small>
                </div>
                <div class="p-field p-col-6 p-md-3  edit-sel">
                    <label for="registerDate">行驶证注册日期
                        <span class="label-sel">*</span>
                    </label>
                    <p-calendar inputId="registerDate" formControlName="registerDate" dateFormat="yy-mm-dd"
                        appendTo="body" dataType="string" class="p-inputtext-sm">
                    </p-calendar>
                    <small *ngIf="checkFormItem(this.validateTruckForm, 'registerDate')" class="p-error block error-msg">
                        请选择行驶证注册日期
                    </small>
                </div>
                <div class="p-field p-col-6 p-md-3  edit-sel">
                    <label for="issueDate">行驶证发证日期
                        <span class="label-sel">*</span>
                    </label>
                    <p-calendar inputId="issueDate" formControlName="issueDate" dateFormat="yy-mm-dd" dataType="string"
                        appendTo="body" class="p-inputtext-sm">
                    </p-calendar>
                    <small *ngIf="checkFormItem(this.validateTruckForm, 'issueDate')" class="p-error block error-msg">
                        请选择行驶证发证日期
                    </small>
                </div>
                <div class="p-field p-col-6 p-md-3 edit-sel">
                    <label for="isOnline">入网状况</label>
                    <p-dp-detail [options]="onlineList" formControlName="isOnline" optionLabel="label"
                        optionValue="value" [style]="{width: '100%'}" appendTo="body" class="p-inputtext-sm">
                    </p-dp-detail>
                </div>
                <div class="p-field p-col-6 p-md-3 edit-sel">
                    <label for="remark">备注</label>
                    <input id="remark" type="text" pInputText formControlName="remark" class="p-inputtext-sm">
                </div>
                <div class="p-field p-col-6 p-md-3  edit-sel">
                    <label for="vehicleExaminedExpirationDate">车辆年审有效期
                        <span class="label-sel">*</span>
                    </label>
                    <p-calendar inputId="vehicleExaminedExpirationDate" formControlName="vehicleExaminedExpirationDate"
                        appendTo="body" dateFormat="yy-mm-dd" dataType="string" class="p-inputtext-sm"></p-calendar>
                    <small *ngIf="checkFormItem(this.validateTruckForm, 'vehicleExaminedExpirationDate')"
                        class="p-error block error-msg">
                        请选择车辆年审有效期
                    </small>
                </div>
            </div>
        </div>
    </form>
    <ng-template pTemplate="footer">
        <p-button icon="pi pi-check" (click)="saveTruck()" label="保存" class="p-button-text"></p-button>
        <button pButton pRipple icon="pi pi-times" type="button" label="取消"
            (click)="myTruck['truckEditDialogFlag'] = false|| dialogBlock = false"
            class="p-button-raised p-button-text p-button-plain"></button>
    </ng-template>
</p-dialog>

<!-- 司机审核弹窗 -->
<p-dialog [(visible)]="this.myTruck['checkDriverTruckDialogFlag']" [modal]="false" [style]="{width: dialog_width_small}"
    [baseZIndex]="10000" [draggable]="true" [resizable]="false" [keepInViewport]="false"
    *ngIf="myTruck['checkDriverTruckDialogFlag']" (onShow)="dialogBlock = true">
    <ng-template pTemplate="header">
        <div class="p-dialog-title">
            人车照审核
        </div>
        <button type="button" [ngClass]="{ 'p-dialog-header-icon p-dialog-header-close p-link': true }"
            (click)="dialogBlock = false || myTruck['checkDriverTruckDialogFlag']= false" pRipple>
            <span class="p-dialog-header-close-icon" class="pi pi-times"></span>
        </button>
    </ng-template>
    <form [formGroup]="checkDriverForm">
        <div class="p-field p-grid">
            <label for="checkFlag" class="p-col-fixed" style="width:90px;">审核状态</label>
            <div class="p-col">
                <p-radioButton name="checkFlag" value="2" class="p-mr-2" inputId="checkPass" formControlName="checkFlag"
                    (onClick)="changeCheckStatus(2)">
                </p-radioButton>
                <label class="p-mr-3" for="checkPass">审核通过</label>
                <p-radioButton name="checkFlag" value="3" class="p-mr-2" inputId="checkReject"
                    formControlName="checkFlag" (onClick)="changeCheckStatus(3)">
                </p-radioButton>
                <label class="p-mr-3" for="checkReject">审核不通过</label>
            </div>
        </div>
        <div class="p-field p-grid" *ngIf="currentDriverCheckFlag == 3">
            <label for="checkLog" class="p-col-fixed" style="width:90px;">不通过原因</label>
            <div class="p-col">
                <input id="checkLog" type="text" pInputText formControlName="checkLog" style="width:100%;">
            </div>
        </div>
    </form>
    <ng-template pTemplate="footer">
        <p-button icon="pi pi-check" (click)="saveCheckDriverTruck()" label="保存" class="p-button-text"></p-button>
        <button pButton pRipple icon="pi pi-times" type="button" label="取消"
            (click)="this.myTruck['checkDriverTruckDialogFlag'] = false|| dialogBlock = false"
            class="p-button-raised p-button-text p-button-plain"></button>
    </ng-template>
</p-dialog>

<!-- 车辆详情 -->
<p-dialog [(visible)]="myTruck['driverTruckPhotoFlag']" position="center" [draggable]="true" [resizable]="false"
    [modal]="false" [header]='myTruck.truckDetailHeader' [style]="{width: dialog_width_small}" [keepInViewport]="false"
    *ngIf="myTruck['driverTruckPhotoFlag']" (onShow)="dialogBlock = true">
    <ng-template pTemplate="header">
        <div class="p-dialog-title">
        </div>
        <button type="button" [ngClass]="{ 'p-dialog-header-icon p-dialog-header-close p-link': true }"
            (click)="dialogBlock = false || myTruck['driverTruckPhotoFlag']= false" pRipple>
            <span class="p-dialog-header-close-icon" class="pi pi-times"></span>
        </button>
    </ng-template>
    <div>
        <div class="upload-photo-box" [style]="{backgroundImage: 'url(' + myTruck['driver_truck_photo_url'] + ')'}">
            <span class="upload-photo upload-photo-span">
                <p-fileUpload #uploadDriverTruckPhoto mode="basic" chooseLabel=""
                    (onSelect)="onSelectTruckFile($event, 'driver_truck_photo')" [fileLimit]="1" accept="image/*"
                    [style]="{'zIndex':'10',opacity:'0',width: '100%', height: '200px'}" name="uploadTruckPhotoFile"
                    maxFileSize="32*1048*1048"></p-fileUpload>
            </span>
            <input #uploadTruckInput type="hidden" (click)="uploadDriverTruckPhoto.clear()" />
        </div>
    </div>
    <ng-template pTemplate="footer">
        <p-button icon="pi pi-check" (click)="saveUploadDriverTruckPhoto()" label="上传" class="p-button-text"></p-button>
        <button pButton pRipple icon="pi pi-times" type="button" label="取消"
            (click)="myTruck['driverTruckPhotoFlag'] = false|| dialogBlock = false"
            class="p-button-raised p-button-text p-button-plain"></button>
    </ng-template>
</p-dialog>

<!-- 车辆详情 -->
<p-detail-sidebar *ngIf="myTruck['showTruckDetailFlag']" [(visible)]="myTruck['showTruckDetailFlag']"
    [showCloseIcon]="false" position="right" [style]="{width:'80%'}" transitionOptions="600ms ease-in-out">
    <app-truck-detail [truckDetail]="myTruck['truckDetail']" (onClose)="closeTruckDetail()"></app-truck-detail>
</p-detail-sidebar>
<!-- =======================================我的车辆结束================================================-->

<!--编辑列-->
<p-dialog [(visible)]="editColumnDialog" [modal]="false" [style]="{width: dialog_width_small}" [baseZIndex]="-100"
    [draggable]="true" [resizable]="false" [keepInViewport]="false" *ngIf="editColumnDialog"
    (onShow)="dialogBlock = true">
    <ng-template pTemplate="header">
        <div class="p-dialog-title">
            编辑列
        </div>
        <button type="button" [ngClass]="{ 'p-dialog-header-icon p-dialog-header-close p-link': true }"
            (click)="saveForRecord(this)" pRipple>
            <span class="p-dialog-header-close-icon" class="pi pi-times"></span>
        </button>
    </ng-template>
    <app-edit-column [keys]="keys"></app-edit-column>
</p-dialog>

<app-common-confirm></app-common-confirm>

<!--查看法大大协议开始-->
<p-dialog class="edit-order" [(visible)]="showFadadaDriverFlag" position="center" [dismissableMask]="true"
    [modal]="false" [style]="{width:'60%', overFlow:'auto'}" [baseZIndex]="10000" *ngIf="showFadadaDriverFlag"
    (onShow)="dialogBlock = true">
    <ng-template pTemplate="header">
        <div class="p-dialog-title">
            {{agreeHeaderTitle}}
        </div>
        <button type="button" [ngClass]="{ 'p-dialog-header-icon p-dialog-header-close p-link': true }"
            (click)="showFadadaDriverFlag= false" pRipple>
            <span class="p-dialog-header-close-icon" class="pi pi-times"></span>
        </button>
    </ng-template>
    <iframe sandbox="allow-same-origin allow-scripts allow-top-navigation allow-forms" scrolling='auto' frameborder='0'
        [src]="safeUrl" [style]="{width:'100%',height:'700px'}"></iframe>
</p-dialog>
<!--查看法大大协议结束-->

<!-- 司机审核开始 -->
<p-detail-sidebar *ngIf="showDriverCheckFlag" [(visible)]="showDriverCheckFlag" [showCloseIcon]="false" position="right"
    [style]="{width:'80%'}" transitionOptions="600ms ease-in-out">
    <app-driver-examine [driverDetail]="localDriverDetail" (onClose)="closeExamDialog()" (onChecked)="queryList()"></app-driver-examine>
</p-detail-sidebar>
<!-- 司机审核结束 -->

<!-- 导出司机数据 -->
<p-dialog [(visible)]="exportDialog" [modal]="false" [style]="{width: dialog_width_small}" [draggable]="true"
    [resizable]="false" [keepInViewport]="false" *ngIf="exportDialog" (onShow)="dialogBlock = true">
    <ng-template pTemplate="header">
        <div class="p-dialog-title">
            导出
        </div>
        <button type="button" [ngClass]="{ 'p-dialog-header-icon p-dialog-header-close p-link': true }"
            (click)="dialogBlock = false || exportDialog= false" pRipple>
            <span class="p-dialog-header-close-icon" class="pi pi-times"></span>
        </button>
    </ng-template>
    <form [formGroup]="exportForm" style="width:100%;padding:24px 16px 0 16px;">
        <div class="p-field p-grid">
            <label for="companyId" class="p-col-fixed" style="width:90px">数据类型：</label>
            <div class="p-col edit-sel">
                <p-radioButton name="exportTemplateType" value="1" class="p-mr-2" inputId="chooseData"
                    formControlName="exportTemplateType">
                </p-radioButton>
                <label class="p-mr-3" for="chooseData">查询数据</label>
                <p-radioButton name="exportTemplateType" value="2" class="p-mr-2" inputId="queryData"
                    formControlName="exportTemplateType" [disabled]="!selectedItem || !selectedItem.length">
                </p-radioButton>
                <label class="p-mr-3" for="queryData">勾选数据</label>
            </div>
        </div>
    </form>
    <ng-template pTemplate="footer">
        <p-button icon="pi pi-check" (click)="exportExcel()" label="确定" class="p-button-text"></p-button>
        <button pButton pRipple icon="pi pi-times" type="button" label="取消"
            (click)="exportDialog = false|| dialogBlock = false"
            class="p-button-raised p-button-text p-button-plain"></button>
    </ng-template>
</p-dialog>

<!-- 导入数据 -->
<p-dialog [(visible)]="importDialog" [modal]="false" [style]="{width: dialog_width_small}" [draggable]="true"
    [resizable]="false" [keepInViewport]="false" *ngIf="importDialog" (onShow)="dialogBlock = true">
    <ng-template pTemplate="header">
        <div class="p-dialog-title">
            导入
        </div>
        <button type="button" [ngClass]="{ 'p-dialog-header-icon p-dialog-header-close p-link': true }"
            (click)="dialogBlock = false || importDialog= false" pRipple>
            <span class="p-dialog-header-close-icon" class="pi pi-times"></span>
        </button>
    </ng-template>
    <form [formGroup]="exportForm" style="width:100%;padding:24px 16px 0 16px;">
        <div class="p-field p-grid">
            <div class="p-md-12 filed-item" style="font-size: 18px;">
                请先下载
                <a href="javascript:;" pRipple (click)="chooseTemplateExcel()" style="color: #f01313;">模板</a>
                ，然后进行导入
            </div>
            <div class="p-md-12 filed-item">
                <div class="upload-photo-box" [style]="{width: '100px', height: '30px'}">
                    <span class="upload-photo upload-photo-span" style="width: '100px'; height: '30px';z-index: 5;">
                        <p-fileUpload #importExcelUpload mode="basic" chooseLabel=""
                            (onSelect)="onSelectImportExcel($event)" [fileLimit]="1" accept=".xls" multiple="multiple"
                            [style]="{'zIndex': '10',opacity:'0',width: '100px', height: '30px'}"
                            maxFileSize="32*1048*1048"></p-fileUpload>
                    </span>
                    <span class="upload-photo upload-photo-span" style="width: '100px'; height: '30px';z-index: 2;">
                        <button pButton pRipple type="button" label="选择" class="p-button-sm" icon="pi pi-cloud-upload"
                            [style]="{'width':'100px'}"></button>
                    </span>
                </div>
            </div>
            <div class="p-md-12 filed-item" style="display: flex;">
                <p-chip *ngIf="uploadExcelFile != null" [label]="uploadExcelFile['name']" styleClass="p-mr-2"
                    [removable]="true" (onRemove)="uploadExcelFile = null"></p-chip>
            </div>
        </div>
    </form>
    <ng-template pTemplate="footer">
        <input type="hidden" #importfileUpload (click)="importExcelUpload.clear()" />
        <p-button icon="pi pi-check" (click)="importCheckExcel()" label="确定" class="p-button-text"></p-button>
        <button pButton pRipple icon="pi pi-times" type="button" label="取消"
            (click)="importDialog = false|| dialogBlock = false"
            class="p-button-raised p-button-text p-button-plain"></button>
    </ng-template>
</p-dialog>


<!-- ==========================关联司机信息开始========================== -->
<p-dialog [(visible)]="relDriverDialogFlag" [modal]="false" [style]="{width: dialog_width_large}" [draggable]="true"
    [resizable]="false" [keepInViewport]="false" *ngIf="relDriverDialogFlag" (onShow)="dialogBlock = true">
    <!-- <ng-template pTemplate="header">
        <span style="font-weight: 600;font-size: large;margin-right:20px;">
            托运方列表
            <span style="font-weight: 700;font-size: small;">( {{ dialogRelTitle }} )</span>
        </span>
    </ng-template> -->
    <ng-template pTemplate="header">
        <div class="p-dialog-title">
            托运方列表
            <span style="font-weight: 700;font-size: small;">( {{ dialogRelTitle }} )</span>
        </div>
        <button type="button" [ngClass]="{ 'p-dialog-header-icon p-dialog-header-close p-link': true }"
            (click)="dialogBlock = false || relDriverDialogFlag= false" pRipple>
            <span class="p-dialog-header-close-icon" class="pi pi-times"></span>
        </button>
    </ng-template>
    <div class="button-panel">
        <button pButton pRipple type="button" label="新增" icon="pi pi-plus" class="p-button-sm p-mr-2"
            (click)="editAgentorRelDriver()"></button>
        <button pButton pRipple type="button" label="删除" [disabled]="selectAgentorRelList.length === 0"
            icon="pi pi-trash" class="p-button-sm p-button-danger" (click)="delRelDriver()"></button>
        <button pButton pRipple type="button" label="刷新" icon="pi pi-search" class="p-button-sm p-ml-2"
            (click)="queryRelDriver()"></button>
    </div>
    <p-table [value]="relAgentorDriverDataList" [loading]="relDriverloading" styleClass="p-datatable-sm"
        [scrollable]="true" scrollHeight="flex" [(selection)]="selectAgentorRelList"
        styleClass="p-datatable-sm  p-datatable-gridlines" [resizableColumns]="true" columnResizeMode="expand">
        <ng-template pTemplate="colgroup" let-columns>
            <colgroup>
                <col style="width:12px">
                <col style="text-align: center;width:120px;" />

            </colgroup>
        </ng-template>
        <ng-template pTemplate="header">
            <tr>
                <th style="width:12px" class="th">
                    <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
                </th>
                <th pResizableColumn style="text-align: center;width:120px;" class="th">托运方名称</th>
                <th pResizableColumn style="text-align: center;width:120px;" class="th">关联时间</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-res>
            <tr>
                <td style="width:12px" class="td">
                    <p-tableCheckbox [value]="res"></p-tableCheckbox>
                </td>
                <td style="text-align: center;width:120px;" class="td">
                    {{keysFunction['cusId'].format(res['shipperId'], res)}}

                </td>
                <td style="text-align: center;width:120px;" class="td">
                    {{keysFunction['createTime'].format(res['createTime'], res)}}

                </td>


            </tr>
        </ng-template>
    </p-table>
    <ng-template pTemplate="footer">
        <div style="height:20px;"></div>
    </ng-template>
</p-dialog>


<!--新增托运方关联开始-->
<p-dialog [(visible)]="editIdCardDialogFlag" [modal]="false" class='edit-data' [style]="{width: '500px' }"
    [draggable]="true" [resizable]="false" [keepInViewport]="false" *ngIf="editIdCardDialogFlag"
    (onShow)="dialogBlock = true">
    <ng-template pTemplate="header">
        <div class="p-dialog-title">
            关联托运方
        </div>
        <button type="button" [ngClass]="{ 'p-dialog-header-icon p-dialog-header-close p-link': true }"
            (click)="dialogBlock = false || editIdCardDialogFlag= false" pRipple>
            <span class="p-dialog-header-close-icon" class="pi pi-times"></span>
        </button>
    </ng-template>
    <form [formGroup]="validateRelDriverForm">
        <div class="p-field p-grid p-col-6 p-md-12">
            <label for="cusId" class="p-col-fixed" style="width:90px">托运方</label>
            <div class="p-col edit-sel">
                <p-dp-detail [options]="ShipperList" formControlName="cusId" filter="true" id="cusId" appendTo="body"
                    class="p-inputtext-sm" emptyMessage="未查询到数据" emptyFilterMessage="未查询到数据" [style]="{width: '100%'}"
                    optionLabel="label" optionValue="value" [showClear]="true" [autoDisplayFirst]="false">
                </p-dp-detail>
                <small *ngIf="checkFormItem(this.validateRelDriverForm, 'cusId')" class="p-error block error-msg">
                    请选择关联托运方
                </small>
            </div>
        </div>

    </form>
    <ng-template pTemplate="footer">
        <button pButton pRipple icon="pi pi-check" type="button" (click)="saveAgentorRelDriver()" label="关联"
            class="p-button-raised"></button>
        <button pButton pRipple icon="pi pi-times" type="button" label="取消"
            (click)="editIdCardDialogFlag = false|| dialogBlock = false"
            class="p-button-raised p-button-text p-button-plain"></button>
    </ng-template>
</p-dialog>


<!-- ==========================关联区域合伙人信息开始========================== -->
<p-dialog [(visible)]="relDriverAgentDialogFlag" [modal]="false" [style]="{width: dialog_width_large}"
    [draggable]="true" [resizable]="false" [keepInViewport]="false" *ngIf="relDriverAgentDialogFlag"
    (onShow)="dialogBlock = true">
    <!-- <ng-template pTemplate="header">
        <span style="font-weight: 600;font-size: large;margin-right:20px;">
            关联区域合伙人列表
            <span style="font-weight: 700;font-size: small;">( {{ dialogRelTitle }} )</span>
        </span>
    </ng-template> -->
    <ng-template pTemplate="header">
        <div class="p-dialog-title">
            关联区域合伙人列表
            <span style="font-weight: 700;font-size: small;">( {{ dialogRelTitle }} )</span>
        </div>
        <button type="button" [ngClass]="{ 'p-dialog-header-icon p-dialog-header-close p-link': true }"
            (click)="dialogBlock = false || relDriverAgentDialogFlag= false" pRipple>
            <span class="p-dialog-header-close-icon" class="pi pi-times"></span>
        </button>
    </ng-template>
    <div class="button-panel">
        <button pButton pRipple type="button" label="新增" icon="pi pi-plus" class="p-button-sm p-mr-2"
            (click)="editAgentRelDriver()"></button>
        <button pButton pRipple type="button" label="删除" [disabled]="selectAgentRelList.length === 0" icon="pi pi-trash"
            class="p-button-sm p-button-danger" (click)="delAgentRelDriver()"></button>
        <button pButton pRipple type="button" label="刷新" icon="pi pi-search" class="p-button-sm p-ml-2"
            (click)="queryRelDriver()"></button>
    </div>
    <p-table [value]="relAgentDriverDataList" [loading]="relDriverloading" styleClass="p-datatable-sm"
        [scrollable]="true" scrollHeight="flex" [(selection)]="selectAgentRelList"
        styleClass="p-datatable-sm  p-datatable-gridlines" [resizableColumns]="true" columnResizeMode="expand">
        <ng-template pTemplate="colgroup" let-columns>
            <colgroup>
                <col style="width:12px">
                <col style="text-align: center;width:120px;" />

            </colgroup>
        </ng-template>
        <ng-template pTemplate="header">
            <tr>
                <th style="width:12px" class="th">
                    <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
                </th>
                <th pResizableColumn style="text-align: center;width:120px;" class="th">区域合伙人名称</th>
                <th pResizableColumn style="text-align: center;width:120px;" class="th">关联时间</th>

            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-res>
            <tr>
                <td style="width:12px" class="td">
                    <p-tableCheckbox [value]="res"></p-tableCheckbox>
                </td>
                <td style="text-align: center;width:120px;" class="td">
                    {{keysFunction['agentId'].format(res['agentId'], res)}}

                </td>
                <td style="text-align: center;width:120px;" class="td">
                    {{keysFunction['createTime'].format(res['createTime'], res)}}

                </td>
            </tr>
        </ng-template>
    </p-table>
    <ng-template pTemplate="footer">
        <div style="height:20px;"></div>
    </ng-template>
</p-dialog>

<!--新增区域合伙人关联开始-->
<p-dialog [(visible)]="editAgentDriverDialogFlag" [modal]="false" class='edit-data' [style]="{width: '500px' }"
    [draggable]="true" [resizable]="false" [keepInViewport]="false" *ngIf="editAgentDriverDialogFlag"
    (onShow)="dialogBlock = true">
    <ng-template pTemplate="header">
        <div class="p-dialog-title">
            关联区域合伙人
        </div>
        <button type="button" [ngClass]="{ 'p-dialog-header-icon p-dialog-header-close p-link': true }"
            (click)="dialogBlock = false || editAgentDriverDialogFlag= false" pRipple>
            <span class="p-dialog-header-close-icon" class="pi pi-times"></span>
        </button>
    </ng-template>
    <form [formGroup]="validateRelAgentDriverForm">
        <div class="p-field p-grid p-col-6 p-md-12">
            <label for="agentId" class="p-col-fixed" style="width:90px">区域合伙人</label>
            <div class="p-col edit-sel">
                <p-dp-detail [options]="agentIdList" formControlName="agentId" filter="true" id="agentId"
                    appendTo="body" class="p-inputtext-sm" emptyMessage="未查询到数据" emptyFilterMessage="未查询到数据"
                    [style]="{width: '100%'}" optionLabel="label" optionValue="value" [showClear]="true"
                    [autoDisplayFirst]="false">
                </p-dp-detail>
                <small *ngIf="checkFormItem(this.validateRelAgentDriverForm, 'agentId')"
                    class="p-error block error-msg">
                    请选择关联区域合伙人
                </small>
            </div>
        </div>

    </form>
    <ng-template pTemplate="footer">
        <button pButton pRipple icon="pi pi-check" type="button" (click)="saveAgentRelDriver()" label="关联"
            class="p-button-raised"></button>
        <button pButton pRipple icon="pi pi-times" type="button" label="取消"
            (click)="editAgentDriverDialogFlag = false|| dialogBlock = false"
            class="p-button-raised p-button-text p-button-plain"></button>
    </ng-template>
</p-dialog>

<!-- 批量查询开始 -->
<p-dialog class="edit-order" [(visible)]="batchMobilePhoneDialog" position="center" *ngIf="batchMobilePhoneDialog"
    [dismissableMask]="false" [modal]="false" [style]="{width: '330px'}" [draggable]="true" [resizable]="false"
    [keepInViewport]="false" (onShow)="dialogBlock = true">
    <ng-template pTemplate="header">
        <div class="p-dialog-title">
            批量查询
        </div>
        <button type="button" [ngClass]="{ 'p-dialog-header-icon p-dialog-header-close p-link': true }"
            (click)="dialogBlock = false || batchMobilePhoneDialog= false" pRipple>
            <span class="p-dialog-header-close-icon" class="pi pi-times"></span>
        </button>
    </ng-template>
    <form [formGroup]="batchNoForm" style="background-color: #ffffff;border-radius: 12px;padding:24px 16px;">

        <div>
            <label id="batchNo" class="label_common">批量查询</label>
            <textarea pInputTextarea formControlName="batchNo" style="width:98%;" rows="15"
                placeholder="打开EXCEL,批量复制司机账号到此处"></textarea>
        </div>

    </form>
    <ng-template pTemplate="footer">
        <p-button icon="pi pi-check" (click)="batchNo()" label="确定" class="p-button-text"></p-button>
        <button pButton pRipple icon="pi pi-times" type="button" label="取消"
            (click)="batchMobilePhoneDialog = flase|| dialogBlock = false"
            class="p-button-raised p-button-text p-button-plain"></button>
    </ng-template>
</p-dialog>

<!-- 批量查询开始 -->
<p-dialog class="edit-order" [(visible)]="batchIdCardNoDialog" position="center" [dismissableMask]="false"
    *ngIf="batchIdCardNoDialog" [modal]="false" [style]="{width: '330px'}" [draggable]="true" [resizable]="false"
    [keepInViewport]="false" (onShow)="dialogBlock = true">
    <ng-template pTemplate="header">
        <div class="p-dialog-title">
            批量查询
        </div>
        <button type="button" [ngClass]="{ 'p-dialog-header-icon p-dialog-header-close p-link': true }"
            (click)="dialogBlock = false || batchIdCardNoDialog= false" pRipple>
            <span class="p-dialog-header-close-icon" class="pi pi-times"></span>
        </button>
    </ng-template>
    <form [formGroup]="batchIdCardNoForm" style="background-color: #ffffff;border-radius: 12px;padding:24px 16px;">

        <div>
            <label id="batchIdCardNo" class="label_common">批量查询</label>
            <textarea pInputTextarea formControlName="batchIdCardNo" style="width:98%;" rows="15"
                placeholder="打开EXCEL,批量复制司机身份证号到此处"></textarea>
        </div>

    </form>
    <ng-template pTemplate="footer">
        <p-button icon="pi pi-check" (click)="batchIdNo()" label="确定" class="p-button-text"></p-button>
        <button pButton pRipple icon="pi pi-times" type="button" label="取消"
            (click)="batchIdCardNoDialog = flase|| dialogBlock = false"
            class="p-button-raised p-button-text p-button-plain"></button>
    </ng-template>
</p-dialog>
<p-dialog
  [(visible)]="batchBindUserDialogFlag"
  [modal]="false"
  class="edit-data"
  [style]="{ width: '400px' }"
  [draggable]="true"
  [resizable]="false"
  [keepInViewport]="false"
  *ngIf="batchBindUserDialogFlag"
  (onShow)="dialogBlock = true"
>
  <ng-template pTemplate="header">
    <div class="p-dialog-title">关联C端</div>

    <button
      type="button"
      [ngClass]="{ 'p-dialog-header-icon p-dialog-header-close p-link': true }"
      (click)="dialogBlock = false || (batchBindUserDialogFlag = false)"
      pRipple
    >
      <span class="p-dialog-header-close-icon" class="pi pi-times"></span>
    </button>
  </ng-template>
  <form [formGroup]="bindTruckUserForm" style="width: 100%; padding: 0 16px 0 16px">
    <div class="p-fluid p-formgrid p-grid">
      <div class="p-field p-grid">
        <label>手机号码 </label>
        &nbsp; &nbsp; &nbsp; &nbsp;
        <p-dp-detail
          (onFilter)="getPlateNumber($event)"
          [options]="userListArr"
          formControlName="SjuserId"
          filter="false"
          id="SjuserId"
          appendTo="body"
          style="width: 100%;"
          class="p-inputtext-sm"
        >
        </p-dp-detail>
      </div>
    </div>
  </form>
  <ng-template pTemplate="footer">
    <p-button icon="pi pi-check" (click)="saveChangeTruckBindUser()" label="确认绑定" class="p-button-text"> </p-button>
    <button
      pButton
      pRipple
      icon="pi pi-times"
      type="button"
      label="取消"
      (click)="batchBindUserDialogFlag = false || (dialogBlock = false)"
      class="p-button-raised p-button-text p-button-plain"
    ></button>
  </ng-template>
</p-dialog>
